/**
 * Created by andrey on 24.05.17.
 */

const ToolFolder = function (listItems) {
    this.listItems = listItems;
};

ToolFolder.create = function (listItems) {
    if (!listItems) {
        return undefined;
    }
    return new ToolFolder(listItems);
};

const ToolEntry = function (isAvailable, entry) {
    this.isAvailable = isAvailable;
    this.entry = entry;
};

ToolEntry.create = function (isAvailable, entry) {
    return new ToolEntry(isAvailable, entry);
};

const stableStringify = (value) => {
    if (!value || typeof value !== "object") {
        return JSON.stringify(value);
    }
    if (Array.isArray(value)) {
        return `[${value.map(stableStringify).join(",")}]`;
    }
    return `{${Object.keys(value).sort().map((key) => `${JSON.stringify(key)}:${stableStringify(value[key])}`).join(",")}}`;
};

const displayToolPrompt = function (callback, text, defaultVal) {
    if (connector.info.isNative || connector.platform.oneOf(connector.INSTANT, connector.WECHAT, connector.YOUTUBE, connector.GAMESNACK)) {
        cleverapps.focusManager.display({
            focus: "Prompt",
            action: function (f) {
                new PromptWindow({ callback, text, defaultVal });
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    } else {
        const value = window.prompt(text, defaultVal);
        if (value !== null && value !== undefined) {
            callback(value);
        }
    }
};

const displayToolWindow = function (func) {
    return function () {
        cleverapps.focusManager.display({
            stack: true,
            focus: "ToolWindow",
            action: function (f) {
                func();
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    };
};

cleverapps.RestClient.send = cleverapps.extendFunc(cleverapps.RestClient.send, function (httpMethod, path, data, onSuccess, onError, options) {
    const simulation = cleverapps.PageSession.get("simulatedNewVersion");
    if (!simulation || !path.startsWith("version.json") && !path.startsWith("/latestversion/")) {
        return this._super(httpMethod, path, data, onSuccess, onError, options);
    }

    if (!simulation.store && cleverapps.newVersionChecker.isReloadsLimitReached()) {
        cleverapps.PageSession.remove("simulatedNewVersion");
        cleverapps.newVersionChecker.lastVersion = undefined;
        cleverapps.newVersionChecker.processVersionChange();
        return this._super(httpMethod, path, data, onSuccess, onError, options);
    }

    if (simulation.once) {
        cleverapps.PageSession.remove("simulatedNewVersion");
        cleverapps.PageSession.remove("simulatedLoadError");
    }

    onSuccess(simulation);
    return undefined;
});

NewVersionChecker.prototype.isStoreApp = cleverapps.extendFunc(NewVersionChecker.prototype.isStoreApp, function () {
    const simulation = cleverapps.PageSession.get("simulatedNewVersion");
    return simulation ? Boolean(simulation.store) : this._super();
});

cleverapps.whenAllInitialized(() => {
    connector.utils.guessPlatformURL = cleverapps.extendFunc(connector.utils.guessPlatformURL, function (options) {
        const simulation = cleverapps.PageSession.get("simulatedNewVersion");
        return this._super(options) || (simulation && simulation.store ? this._super({ source: "android" }) : undefined);
    });
});

if (cleverapps.PageSession.get("simulatedContextLost")) {
    const create3DContext = cc.create3DContext;
    cc.create3DContext = function (canvas, attributes) {
        const context = create3DContext(canvas, attributes);
        const loseContext = context && context.getExtension("WEBGL_lose_context");
        if (loseContext) {
            loseContext.loseContext();
        }
        return context;
    };
}

const splitEntriesInParts = function f(items, actionFunc) {
    const res = {};
    let batch = {};

    items.forEach((item, ind) => {
        batch[item.name] = actionFunc.bind(undefined, item, ind);

        if (Object.keys(batch).length === 30) {
            res[`part${Object.keys(res).length}`] = batch;
            batch = {};
        }
    });

    if (Object.keys(batch).length) {
        res[`part${Object.keys(res).length}`] = batch;
    }
    return res;
};

// eslint-disable-next-line no-unused-vars
const dialogues = function () {
    const showDialogue = function (steps) {
        cleverapps.focusManager.display({
            focus: "ToolDialogue",
            action: function (f) {
                const dialogue = new Dialogue(steps, {
                    showUp: true,
                    autoClose: true,
                    autoScroll: false,
                    imageBundle: (bundles.dialogues_images || bundles.dialogues || {}).name
                });

                dialogue.on("afterClose", f);
                new DialogueView(dialogue);
            }
        });
    };

    // spine -> a window bundle that shows it, hardcoded per game (no scanning)
    const WINDOW_PERSONS = {
        mergecraft: {
            king_happy: "starter_pack",
            king_idle: "conflict_window",
            king_sad: "confirmexit_window",
            seller_merchant: "growth_fund",
            worker_happy: "workerwindow",
            worker_thinking: "ruinswindow"
        },
        wondermerge: {
            dwarf_happy: "rate_window",
            dwarf_idle: "starter_pack",
            dwarf_sad: "confirmexit_window",
            dwarf_thinking: "conflict_window",
            dwarf_determined: "krakenfeast_window",
            worker_happy: "workerwindow",
            worker_thinking: "ruinswindow"
        },
        fairy: {
            dwarf_happy: "starter_pack",
            dwarf_idle: "dailytasks",
            dwarf_sad: "confirmexit_window",
            dwarf_thinking: "conflict_window",
            dwarf_determined: "krakenfeast_window",
            worker_happy: "workerwindow",
            worker_thinking: "ruinswindow"
        },
        hustlemerge: {
            dwarf_happy: "starter_pack",
            dwarf_idle: "dailytasks",
            dwarf_sad: "confirmexit_window",
            dwarf_thinking: "conflict_window",
            seller_merchant: "buyfogwindow_person",
            worker_happy: "workerwindow",
            worker_thinking: "ruinswindow"
        }
    };

    // open the real window and show its person spine on the given side ("left" by default)
    const showWindowPerson = function (target) {
        const [bundleName, side] = target.split("|");
        const jsonKey = side === "right" ? "personRight" : "personLeft";

        cleverapps.focusManager.display({
            stack: true,
            focus: "ToolWindowPerson",
            action: function (f) {
                cleverapps.bundleLoader.loadBundle(bundleName, {
                    onSuccess: function () {
                        const json = bundles[bundleName].jsons[jsonKey];
                        if (!json) {
                            cleverapps.notification.create(`${bundleName} has no ${jsonKey}`);
                            cleverapps.bundleLoader.deleteBundle(bundleName);
                            f();
                            return;
                        }

                        const window = new SettingsWindow();

                        const persons = new WindowPersons({
                            [side === "right" ? "right" : "left"]: { json }
                        }, window, [window.wrapper, window.tapToContinue]);
                        window.persons = persons;
                        persons.positionPersons();
                        persons.showUp();

                        cleverapps.focusManager.onceNoWindowsListener = function () {
                            cleverapps.bundleLoader.deleteBundle(bundleName);
                            f();
                        };
                    }
                });
            }
        });
    };

    const mapToMenu = function (menu) {
        const res = {};

        Object.keys(menu).forEach((title) => {
            res[title] = function () {
                const item = menu[title];
                if (item.options) {
                    showDialogue(item.steps);
                } else {
                    showDialogue(item);
                }
            };
        });

        return res;
    };

    const listPersons = function () {
        const res = {};

        const allPersons = cleverapps.persons.getData();
        for (const role in allPersons) {
            const personName = allPersons[role].name;

            res[`${role}:${personName}`] = {
                steps: [
                    {
                        // eslint-disable-next-line max-len
                        text: "Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet.",
                        person: role,
                        person2: {
                            role,
                            orientation: "right"
                        }
                    },
                    {
                        text: "Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet.",
                        person: {
                            role,
                            orientation: "right"
                        },
                        person2: role
                    },
                    {
                        text: "Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet.",
                        person: role,
                        person2: {
                            role,
                            orientation: "right"
                        }
                    }
                ],
                options: { bundle: personName }
            };
        }

        return res;
    };

    const listMinimals = function () {
        const minimals = {};

        Object.keys(cleverapps.config.personsMinimal).forEach((role) => {
            const personName = cleverapps.config.personsMinimal[role];

            const showMinimal = function () {
                cleverapps.focusManager.display({
                    focus: "testMinimal",
                    action: function (f) {
                        cleverapps.forces.create(ForceView.NO_ELEMENT, {
                            text: "Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet.",
                            person: role,
                            delay: 0.5,
                            position: MinimalDialogue.POSITIONS.CENTER
                        });
                        cleverapps.forces.onceForceClosed = f;
                    }
                });
            };

            minimals[`${role}:${personName}`] = function () {
                showMinimal();
            };
        });

        return minimals;
    };

    const listPlot = function () {
        const steps = {};
        for (const article in cleverapps.styles.dialogues) {
            const step = cleverapps.styles.dialogues[article].dialogue;
            steps[article] = step;
        }

        return steps;
    };

    const groupByCode = (keys) => {
        const groups = {};

        keys.forEach((key) => {
            const lastUnderscore = key.lastIndexOf("_");
            const code = lastUnderscore > 0 ? key.substring(0, lastUnderscore) : key;

            if (!groups[code]) {
                groups[code] = [];
            }
            groups[code].push(key);
        });

        return groups;
    };

    const loadAndList = (bundleName, listFn) => ToolFolder.create(() => {
        if (cleverapps.bundleLoader.isLoaded(bundleName)) {
            return listFn();
        }

        return {
            load: () => {
                cleverapps.bundleLoader.loadBundle(bundleName, {
                    onSuccess: () => {
                        cleverapps.toolModel.refresh();
                    }
                });
            }
        };
    });

    const listUnitStories = () => {
        const locations = {};

        Object.values(Meta.GetAvailableLocations()).forEach((location) => {
            const bundleName = `unitstories_${location.id}`;
            if (!bundles[bundleName] || !bundles[bundleName].jsons.unitstories_json) {
                return;
            }

            locations[location.id] = loadAndList(bundleName, () => {
                const unitStories = bundles[bundleName].jsons.unitstories_json.resolve().getJson();
                const groups = groupByCode(Object.keys(unitStories).filter((key) => key !== "__meta__" && unitStories[key] && unitStories[key].dialogue));

                const res = {};
                Object.keys(groups).forEach((code) => {
                    res[code] = {};
                    groups[code].forEach((key) => {
                        res[code][key] = () => {
                            showDialogue(unitStories[key].dialogue);
                        };
                    });
                });
                return res;
            });
        });

        return locations;
    };

    const listQuestDialogues = () => {
        if (typeof QuestsConfig === "undefined") {
            return {};
        }

        const locations = {};

        Object.values(Meta.GetAvailableLocations()).forEach((location) => {
            let bundleName = `quests_${location.id}`;
            if (!bundles[bundleName] || !bundles[bundleName].jsons.quests_json) {
                bundleName = `quests_${location.meta && location.meta.units}`;
                if (!bundles[bundleName] || !bundles[bundleName].jsons.quests_json) {
                    return;
                }
            }

            const locationBundleName = bundleName;

            locations[location.id] = loadAndList(locationBundleName, () => {
                const questsData = bundles[locationBundleName].jsons.quests_json.resolve().getJson();
                const keys = Object.keys(questsData).filter((key) => key !== "__meta__" && questsData[key] && questsData[key].dialogue);

                const groups = groupByCode(keys);
                const res = {};
                Object.keys(groups).forEach((code) => {
                    res[code] = {};
                    groups[code].forEach((key) => {
                        res[code][key] = () => {
                            showDialogue(questsData[key].dialogue);
                        };
                    });
                });
                return res;
            });
        });

        return locations;
    };

    const res = {
        persons: mapToMenu(listPersons()),
        minimals: listMinimals(),
        plot: mapToMenu(listPlot()),
        unitStories: listUnitStories(),
        quests: listQuestDialogues(),
        personsGallery: ["idle", "happy", "sad", "thinking", "determined"].reduce((acc, emotion) => {
            acc[emotion] = () => {
                cleverapps.focusManager.display({
                    stack: true,
                    focus: "PersonsGalleryWindow",
                    action: (f) => {
                        new PersonsGalleryWindow(f, emotion);
                    }
                });
            };
            return acc;
        }, {})
    };

    const gameWindowPersons = WINDOW_PERSONS[cleverapps.config.name];
    if (gameWindowPersons) {
        res.windowPersons = Object.keys(gameWindowPersons).reduce((acc, spine) => {
            acc[spine] = () => showWindowPerson(gameWindowPersons[spine]);
            return acc;
        }, {});
    }

    if (cleverapps.styles.comicses) {
        res.comics = (function () {
            const comicses = {};
            Object.keys(cleverapps.styles.comicses).forEach((key) => {
                comicses[ColorComponent.CODE_COLORS[key] ? ColorComponent.CODE_COLORS[key] : key] = function () {
                    cleverapps.focusManager.display({
                        focus: "ToolComics",
                        actions: [
                            function (f) {
                                ComicsScene.showComics(f, cleverapps.styles.comicses[key]);
                            },
                            function (f) {
                                cleverapps.meta.gotoMainLocation(f);
                            }]
                    });
                };
            });

            return comicses;
        }());
    }

    return res;
};

cleverapps.Tool = {
    snapshots: ToolFolder.create(() => {
        const res = {
            resetDate: function () {
                if (cleverapps.loadedSnapshot) {
                    cleverapps.notification.create("resetDate unavailable in snapshots. Import snapshot to enable resetDate");
                    return;
                }

                SnapshotAdapters.extractData((snapshot) => {
                    const delta = DateShift.getDelta();
                    let expandSeconds;

                    const expandTime = cleverapps.expandTime;
                    cleverapps.expandTime = function (time, options) {
                        const result = expandTime.call(this, time, options);
                        return result != null ? result && result - delta : result;
                    };

                    if (typeof UnitPacker !== "undefined") {
                        expandSeconds = UnitPacker.expandSeconds;
                        UnitPacker.expandSeconds = function (time, key) {
                            return expandSeconds.call(this, time) - (key === "limit" ? 0 : delta);
                        };
                    }

                    snapshot = JSON.parse(JSON.stringify(snapshot));

                    delete snapshot.date;

                    const matchPath = function (path, pattern) {
                        const regexp = pattern
                            .replace(/[.+?^${}()|[\]\\]/g, "\\$&")
                            .replace(/\*\*/g, " ")
                            .replace(/\*/g, "[^/]*")
                            // eslint-disable-next-line no-control-regex
                            .replace(/ /g, ".*");
                        return new RegExp(`^${regexp}$`).test(path);
                    };

                    const isKeptDate = function (path, obj) {
                        if (["/forces*", "/fogs*"].some((pattern) => matchPath(path, pattern))) {
                            return true;
                        }

                        if (["/missions/*/started", "/missions/*/lastRemoved"].some((pattern) => matchPath(path, pattern))) {
                            const missionConfig = Missions[obj.type];
                            return Boolean(missionConfig && missionConfig.oncePerEvent && missionConfig.feature);
                        }

                        return false;
                    };

                    const processDate = function (obj, root) {
                        for (const name in obj) {
                            const path = `${root}${name}`;

                            if (isKeptDate(path, obj)) {
                                continue;
                            }

                            if (typeof obj[name] === "number") {
                                if (obj[name] > cleverapps.ZERO_DATE) {
                                    obj[name] -= delta;
                                }
                            } else if (typeof obj[name] === "object") {
                                processDate(obj[name], `${path}/`);
                            }
                        }
                    };
                    processDate(snapshot, "/");

                    cleverapps.snapshots.importSnapshot(snapshot);

                    cleverapps.focusManager.whenFreeFocus(() => {
                        cleverapps.expandTime = expandTime;
                        if (typeof UnitPacker !== "undefined") {
                            UnitPacker.expandSeconds = expandSeconds;
                        }
                    });
                });
            }
        };

        Object.keys(bundles.snapshots.jsons).filter((name) => name !== "debug_meta_json").sort((a, b) => {
            const aParts = a.split("_");
            const bParts = b.split("_");
            for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
                const aInt = parseInt(aParts[i]);
                const bInt = parseInt(bParts[i]);

                if (isNaN(aInt) && isNaN(bInt)) {
                    return a.level - b.level;
                }
                if (!isNaN(aInt) && isNaN(bInt)) {
                    return 1;
                }
                if (isNaN(aInt) && !isNaN(bInt)) {
                    return -1;
                }
                if (!isNaN(aInt) && !isNaN(bInt)) {
                    return aInt - bInt;
                }
            }
            return 0;
        }).forEach((name) => {
            res[name] = function () {
                cleverapps.bundleLoader.loadBundle("snapshots", {
                    onSuccess: function () {
                        const snapshot = cc.loader.getRes(bundles.snapshots.jsons[name]);
                        cleverapps.snapshots.importSnapshot(snapshot);
                    }
                });
            };
        });

        if (cleverapps.config.importMode) {
            const importModeCommands = {
                download: function () {
                    cleverapps.snapshots.exportToJson(cleverapps.loadedSnapshot);
                }
            };

            return Object.assign(importModeCommands, res);
        }

        return {
            import: function () {
                cleverapps.snapshots.importFromUrl((snapshot) => {
                    cleverapps.snapshots.importSnapshot(snapshot);
                });
            },

            importJson: function () {
                const input = document.createElement("input");
                input.type = "file";

                input.onchange = function (event) {
                    const reader = new FileReader();
                    reader.onload = function (event) {
                        cleverapps.snapshots.importSnapshot(JSON.parse(event.target.result.toString()));
                    };
                    reader.readAsText(event.target.files[0]);
                };

                input.click();
            },

            download: function () {
                cleverapps.snapshots.importFromUrl((snapshot) => {
                    cleverapps.snapshots.exportToJson(snapshot);
                });
            },
            ...res 
        };
    }),

    "Meta homefix": ToolFolder.create(() => (cleverapps.meta.getSelectedLocation().locationConfig.locationType === "homefix" ? {
        checkClimbables: function () {
            if (!Homefix.currentHomefix) {
                return;
            }

            console.log(Map2dDecorators.findDuplicateAndMissingClimbables());
        },

        add20Stars: function () {
            cleverapps.meta.getSelectedLocation().changeStars(20);
        },

        resetStars: function () {
            cleverapps.meta.getSelectedLocation().resetStars();
        }
    } : undefined)), 

    Navigation: (!["merge", "merge2"].includes(cleverapps.config.type)) ? {
        goto_episode: function () {
            cleverapps.Tool.Navigation.goto_level("goto_episode");
        },

        goto_level: function (type) {
            const callback = function (level) {
                if (type === "goto_episode" && parseInt(level) >= 0) {
                    level = parseInt(level) * 15 + 1;
                }
                if (level) {
                    level = parseInt(level) - 1;

                    levels.user.currentPhysicalLevel.level = level % Level.LEVELS_PER_EPISODE;
                    levels.user.currentPhysicalLevel.episode = Math.floor(level / Level.LEVELS_PER_EPISODE);
                    levels.user.currentPhysicalLevel.progress = 0;

                    const total = levels.user.getEpisodesAmount();
                    if (levels.user.currentPhysicalLevel.episode >= total) {
                        levels.user.currentPhysicalLevel.episode = total;
                        levels.user.currentPhysicalLevel.level = 0;
                        levels.user.currentPhysicalLevel.progress = level - levels.user.getHumanReadableNumber() + 1;
                    }
                    cleverapps.user.trigger("recheckAvailable");
                    cleverapps.user.save();

                    if (["riddles", "crocword"].includes(cleverapps.config.name)) {
                        const slot = cleverapps.dataSlots.getSlot(Meta.SLOT_MAIN);
                        slot.reset();
                        slot.save("stage", levels.user.currentPhysicalLevel.episode);
                        slot.save("progress", levels.user.currentPhysicalLevel.level);

                        cleverapps.meta.resetProgress();
                    }

                    if (["olympics"].includes(cleverapps.config.name)) {
                        const total = levels.user.currentPhysicalLevel.episode * Level.LEVELS_PER_EPISODE + levels.user.currentPhysicalLevel.level + levels.user.currentPhysicalLevel.progress;
                        const stage = Math.floor(total / ShortMetaLocation.LEVELS_PER_LOCATION) || 0;
                        const progress = (total % ShortMetaLocation.LEVELS_PER_LOCATION) || 0;

                        const slot = cleverapps.dataSlots.getSlot(Meta.SLOT_MAIN);
                        slot.reset();
                        slot.save("stage", stage);
                        slot.save("progress", progress);

                        cleverapps.meta.resetProgress();
                    }

                    cleverapps.dataLoader.processSaveQueue();

                    if (cleverapps.playButton) {
                        cleverapps.playButton.update();
                    }

                    if (cleverapps.isKnockoutGame()) {
                        cleverapps.knockoutGame.setLevel(level);
                        cleverapps.meta.save();
                    }

                    if (typeof match3 !== "undefined" && match3 && match3.heroes) {
                        match3.heroes.checkAvailableToOpen();
                    }

                    cleverapps.sideBar.refreshAllIcons();
                    cleverapps.refreshScene();
                }
            };

            const episodes = levels.user.getEpisodesAmount();
            const text = type === "goto_episode"
                ? `Episode (0...${episodes - 1}, ${episodes} episodes)`
                : `Level (1...${episodes * Level.LEVELS_PER_EPISODE}, ${episodes} episodes of ${Level.LEVELS_PER_EPISODE})`;
            displayToolPrompt(callback, text, 15);
        }
    } : undefined,

    "Meta hose": ToolFolder.create(() => (cleverapps.meta.getSelectedLocation().locationConfig.locationType === "hose" ? {
        pass_all: () => {
            const location = cleverapps.meta.getSelectedLocation();
            while (location.canMoveNext()) {
                if (location.isCompleted()) {
                    location.setStage(location.stage + 1);
                    location.setProgress(0);
                } else {
                    location.setProgress(location.getProgress() + 1);
                }
            }

            cleverapps.refreshScene();
        },

        pass_level: function () {
            const location = cleverapps.meta.getSelectedLocation();
            location.gamePlayed({
                outcome: GameBase.OUTCOME_VICTORY
            });

            cleverapps.refreshScene();
        }
    } : undefined)),

    "Meta farm": ToolFolder.create(() => (cleverapps.meta.getSelectedLocation().locationConfig.locationType === "farm" ? {
        gotoBuilding: ToolFolder.create(() => {
            const farm = cleverapps.meta.getSelectedLocation();
            if (!farm) {
                return [];
            }

            const actionFunc = function (building, ind) {
                const farm = cleverapps.meta.getSelectedLocation();
                farm.reset();

                const newData = FarmLocation.GetBuildingProgress(ind, 0);
                farm.load(newData);
                farm.save();
                cleverapps.refreshScene();
            };

            return splitEntriesInParts(farm.config.items, actionFunc);
        }),

        nextBuilding: function () {
            const farm = cleverapps.meta.getSelectedLocation();

            if (farm.isCompleted()) {
                return;
            }

            FarmTool.set(farm.currentBuildingId + 1, 0, true);

            cleverapps.focusManager.display({
                focus: "ToolMoveNext",
                action: function (f) {
                    farm.moveNext(f);
                }
            });
        },

        nextQuest: function () {
            const farm = cleverapps.meta.getSelectedLocation();

            if (farm.isCompleted()) {
                return;
            }

            const nextProgress = FarmTool.calcNextProgress(farm.getBuilding());
            FarmTool.set(nextProgress.buildingId, nextProgress.questId, true);

            cleverapps.focusManager.display({
                focus: "ToolMoveNext",
                action: function (f) {
                    farm.moveNext(f);
                }
            });
        },

        passAll: function () {
            const farm = cleverapps.meta.getSelectedLocation();

            FarmTool.set(farm.buildings.length, 0);

            cleverapps.refreshScene();
        },

        listQuestItems: ToolFolder.create(() => {
            const farm = cleverapps.meta.getSelectedLocation();

            if (!farm || !farm.getBuilding() || !farm.getBuilding().getQuest()) {
                return;
            }

            const res = {};
            const quest = farm.getBuilding().getQuest();
            const keys = farm.keys;
            quest.items.forEach((item) => {
                res[item.name] = function () {
                    const currentAmount = keys[item.name] || 0;
                    const amount = parseInt(window.prompt(`${item.name} ${currentAmount}/${item.amount}`, currentAmount));
                    if (!isNaN(amount)) {
                        keys[item.name] = amount;
                        farm.save();
                    }
                };
            });
            return res;
        }),

        setItems: function () {
            const farm = cleverapps.meta.getSelectedLocation();
            const input = window.prompt("Enter required items \n e.g. coke=2,mentos=5");
            if (input) {
                input.replace(/ /g, "").split(",").forEach((item) => {
                    const index = item.indexOf("=");
                    const key = item.substr(0, index);
                    const val = parseInt(item.substr(index + 1));
                    farm.keys[key] = val;
                    farm.save();
                });
            }
        },

        addCurrentQuestItems: function (isLastLevel) {
            const farm = cleverapps.meta.getSelectedLocation();
            const quest = farm.getBuilding().getQuest();
            if (quest) {
                const keys = farm.keys;
                quest.items.forEach((item, index) => {
                    if (!keys[item.name]) {
                        keys[item.name] = 0;
                    }

                    if (keys[item.name] < item.amount) {
                        keys[item.name] = item.amount;
                    }
                    if (isLastLevel === true && index === 0) {
                        keys[item.name]--;
                    }
                });
            }
            farm.save();
        },

        addAllItems: function () {
            const keys = {};
            cleverapps.meta.getSelectedLocation().buildings.forEach((building) => {
                if (keys[building.provides]) {
                    return;
                }
                keys[building.provides] = true;
                for (let i = 0; i < 1000; i++) {
                    cleverapps.meta.getSelectedLocation().keys[building.provides] = 1000;
                }
            });

            cleverapps.meta.getSelectedLocation().save();
        },

        lastLevel: function () {
            const farm = cleverapps.meta.getSelectedLocation();

            FarmTool.set(farm.buildings.length, 0, true);

            cleverapps.refreshScene();
        },

        inspectByBuildings: ToolFolder.create(() => {
            const actionFunc = function (building) {
                const provides = [];

                for (let level = 1; level <= 100; level++) {
                    let levelProvide = [0, 0, 0];

                    if (building.id === 0 && level === 1) {
                        levelProvide = [3, 0, 0];
                    } else {
                        const pseudo = PseudoRandom.GET("secondary");
                        pseudo.seed(building.id * 10000 + level);

                        for (let i = 0; i < 3; i++) {
                            const t = pseudo.nextDouble();
                            if (t < cleverapps.meta.getSelectedLocation().probabilities[0]) {
                                levelProvide[0]++;
                            } else if (t < cleverapps.meta.getSelectedLocation().probabilities[1]) {
                                levelProvide[1]++;
                            } else {
                                levelProvide[2]++;
                            }
                        }
                    }
                    provides.push(levelProvide);
                }
                console.log(building.name, provides);
            };

            return splitEntriesInParts(cleverapps.meta.getSelectedLocation().buildings, actionFunc);
        }),

        inspect: function () {
            const data = [];
            const fakeKeys = {};
            const fakeBuildingLevels = {};
            const skippedItems = [];

            const farm = cleverapps.meta.getSelectedLocation();
            if (!farm) {
                return;
            }

            let totalLlvs = 0;

            farm.buildings.forEach((building) => {
                const ind = data.push({}) - 1;
                data[ind][building.name] = {};
                fakeBuildingLevels[building.name] === undefined && (fakeBuildingLevels[building.name] = 0);

                building.quests.forEach((quest) => {
                    let levelsOnQuest = 0;
                    const totalQuestProvides = {};
                    data[ind][building.name][Messages.get(quest.title)] = {
                        perItems: {}
                    };

                    quest.items.forEach((item) => {
                        if (fakeKeys[item.name] === undefined) {
                            fakeKeys[item.name] = 0;
                        }
                        const totalItemProvides = {};
                        let levelsOnItem = 0;

                        while (fakeKeys[item.name] < item.amount) {
                            levelsOnItem++;
                            levelsOnQuest++;
                            const targetBuilding = farm.findProperBuilding(item);
                            fakeBuildingLevels[targetBuilding.name] === undefined && (fakeBuildingLevels[targetBuilding.name] = 0);
                            fakeBuildingLevels[targetBuilding.name]++;

                            const itemName = targetBuilding.provides;
                            fakeKeys[itemName] === undefined ? fakeKeys[itemName] = 1 : fakeKeys[itemName]++;
                            totalItemProvides[itemName] === undefined ? totalItemProvides[itemName] = 1 : totalItemProvides[itemName]++;
                            totalQuestProvides[itemName] === undefined ? totalQuestProvides[itemName] = 1 : totalQuestProvides[itemName]++;
                        }

                        if (!levelsOnItem) {
                            skippedItems.push(`${item.name} - ${Messages.get(quest.title)} (${building.name})`);
                        }

                        fakeKeys[item.name] -= item.amount;
                        data[ind][building.name][Messages.get(quest.title)].perItems[item.name] = {
                            earnedOnItem: cleverapps.clone(totalItemProvides),
                            levelsOnItem
                        };
                    });

                    data[ind][building.name][Messages.get(quest.title)].earnedOnQuest = cleverapps.clone(totalQuestProvides);
                    data[ind][building.name][Messages.get(quest.title)].levelsOnQuest = levelsOnQuest;
                    totalLlvs += levelsOnQuest;
                    data[ind][building.name][Messages.get(quest.title)].total = cleverapps.clone(fakeKeys);
                });
            });

            data.push({
                total: cleverapps.clone(fakeKeys),
                skippedItems,
                totalLvls: totalLlvs
            });

            data.forEach((item) => {
                console.log(item);
            });

            console.log("Print clock to get json data");
            clock = JSON.stringify(data);
        }
    } : undefined)),

    "Meta garden": ToolFolder.create(() => (typeof RepairLocation !== "undefined" ? {
        reset: function () {
            cleverapps.meta.resetProgress();
            cleverapps.meta.save();

            cleverapps.refreshScene();
        },

        resetLocation: function () {
            const location = cleverapps.meta.getSelectedLocation();
            location.changeBuilding(0);
            location.trigger("reset");
            Merge2.current && Merge2.current.customers.clearCooldown();
            Merge2.current.recalcLevelProgress();
        },

        setLocationStage: function () {
            displayToolPrompt((amount) => {
                amount = parseInt(amount);
                if (amount) {
                    const location = cleverapps.meta.getSelectedLocation();
                    const currentStage = location.getCurrentStage();
                    location.setStage(amount);
                    location.trigger("reset");
                    if (amount < currentStage) {
                        Merge2.current && Merge2.current.customers.clearCooldown();
                    }
                    Merge2.current.recalcLevelProgress();
                }
            }, "Enter amount", 10);
        },

        setLastStage: function () {
            const location = cleverapps.meta.getSelectedLocation();
            location.setStage(location.getStagesInBuilding() - 1);
            location.trigger("reset");
            cleverapps.placements.onFocusLostListenerPlacements();
            Merge2.current.recalcLevelProgress();
        },

        add1: function () {
            const location = cleverapps.meta.getSelectedLocation();
            location.stars.addStars(1);
        },

        add10: function () {
            const location = cleverapps.meta.getSelectedLocation();
            location.stars.addStars(10);
        },

        addStars: function () {
            displayToolPrompt((amount) => {
                amount = parseInt(amount);
                if (amount) {
                    const location = cleverapps.meta.getSelectedLocation();
                    location.stars.addStars(amount);
                }
            }, "Enter amount", 10);
        },

        starsReset: function () {
            const location = cleverapps.meta.getSelectedLocation();
            location.stars.addStars(-location.stars.getAmount());
        },

        setCurrentLocation: function () {
            cleverapps.focusManager.display({
                stack: true,
                focus: "EditorLocationSceneOpen",
                action: function (f) {
                    displayToolPrompt((amount) => {
                        amount = parseInt(amount);
                        if (!isNaN(amount)) {
                            cleverapps.meta.mainLocationId = amount || 0;
                            cleverapps.meta.save();
                            cleverapps.meta.gotoMainLocation(f);
                        }
                    });
                }
            });
        }
    } : undefined)),

    "Location ladacha": ToolFolder.create(() => (typeof LadachaIslandView !== "undefined" ? {
        reset: function () {
            cleverapps.meta.resetProgress();
            cleverapps.meta.save();

            cleverapps.refreshScene();
        },

        resetLocation: function () {
            cleverapps.meta.getSelectedLocation().reset();
            Merge2.current && Merge2.current.customers.clearCooldown();
            Merge2.current.recalcLevelProgress();
        },

        setLocationStage: function () {
            displayToolPrompt((amount) => {
                amount = parseInt(amount);
                if (amount) {
                    const location = cleverapps.meta.getSelectedLocation();
                    const currentStage = location.getCurrentStage();
                    location.setStage(amount);
                    location.trigger("reset");
                    if (amount < currentStage) {
                        Merge2.current && Merge2.current.customers.clearCooldown();
                    }
                    Merge2.current.recalcLevelProgress();
                }
            }, "Enter amount", 10);
        },

        setLocationBuilding: function () {
            displayToolPrompt((amount) => {
                amount = parseInt(amount);
                if (amount) {
                    const location = cleverapps.meta.getSelectedLocation();
                    const currentBuilding = location.getCurrentBuilding();
                    location.changeBuilding(amount);
                    location.trigger("reset");
                    if (amount < currentBuilding) {
                        Merge2.current && Merge2.current.customers.clearCooldown();
                    }
                    Merge2.current.recalcLevelProgress();
                }
            }, "Enter amount", 10);
        },

        setLastBuilding: function () {
            const location = cleverapps.meta.getSelectedLocation();
            location.changeBuilding(location.getBuildingsInRoom(location.getCurrentRoom()) - 1);
            location.trigger("reset");
            Merge2.current.recalcLevelProgress();
        },

        setLastStage: function () {
            const location = cleverapps.meta.getSelectedLocation();
            location.setStage(location.getStagesInBuilding() - 1);
            location.trigger("reset");
            Merge2.current.recalcLevelProgress();
        },

        add1: function () {
            const location = cleverapps.meta.getSelectedLocation();
            location.stars.addStars(1);
        },

        add10: function () {
            const location = cleverapps.meta.getSelectedLocation();
            location.stars.addStars(10);
        },

        addStars: function () {
            displayToolPrompt((amount) => {
                amount = parseInt(amount);
                if (amount) {
                    const location = cleverapps.meta.getSelectedLocation();
                    location.stars.addStars(amount);
                }
            }, "Enter amount", 10);
        },

        starsReset: function () {
            const location = cleverapps.meta.getSelectedLocation();
            location.stars.addStars(-location.stars.getAmount());
        },

        openTravelMap: function () {
            cleverapps.focusManager.display({
                focus: "TravelMapWindow",
                action: function (f) {
                    new TravelMapWindow();
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        },

        toggleFogs: function () {
            cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).roomView.toggleFogs();
        }
    } : undefined)),

    "Meta simple": ToolFolder.create(() => (cleverapps.meta.getSelectedLocation().locationConfig.locationType === "simple" ? {
        reset: function () {
            const location = cleverapps.meta.getSelectedLocation();
            const slot = location.slot;

            slot.reset();
            cleverapps.meta.switchLocation(location.locationId);

            if (cleverapps.knockoutGame) {
                cleverapps.knockoutGame.reset();
            }

            cleverapps.refreshScene();
        },

        moveNext: function () {
            const location = cleverapps.meta.getSelectedLocation();
            location.setProgress(location.getRequiredProgress() - 3);
            location.changeProgress(3);

            cleverapps.placements.onFocusLostListenerPlacements();
        },

        moveTo: ToolFolder.create(() => {
            const moveTo = function (item, stage) {
                const location = cleverapps.meta.getSelectedLocation();
                location.setStage(stage);

                cleverapps.refreshScene();
            };

            const entries = [];
            const location = cleverapps.meta.getSelectedLocation();

            for (let stage = 0; !location.isComingSoonStage(stage); stage++) {
                entries.push({
                    name: Messages.has(`background_name_${stage}`) ? Messages.get(`background_name_${stage}`) : `UNNAMED_${stage}`
                });
            }

            return splitEntriesInParts(entries, moveTo);
        }),

        passAll: () => {
            const location = cleverapps.meta.getSelectedLocation();

            while (!location.isLocationCompleted()) {
                if (location.isCompleted()) {
                    location.setProgress(0);
                    location.setStage(location.getStage() + 1);
                } else {
                    location.setProgress(location.getProgress() + 1);
                }
            }

            cleverapps.refreshScene();
        },

        add1: function () {
            const location = cleverapps.meta.getSelectedLocation();
            location.changeProgress(1);

            cleverapps.placements.onFocusLostListenerPlacements();
        },

        add10: function () {
            const location = cleverapps.meta.getSelectedLocation();
            location.changeProgress(10);

            cleverapps.placements.onFocusLostListenerPlacements();
        },

        addStars: function () {
            const amount = parseInt(window.prompt("Enter amount", 10));
            if (amount) {
                const location = cleverapps.meta.getSelectedLocation();
                location.changeProgress(amount);

                cleverapps.placements.onFocusLostListenerPlacements();
            }
        }
    } : undefined)),

    UI: {
        dialogues: ToolFolder.create(dialogues),

        skins: ToolFolder.create(() => {
            const res = {};
            Object.keys(cleverapps.SkinManager.SKINS).forEach((skin) => {
                res[skin] = function () {
                    cleverapps.eventManager.events = cleverapps.eventManager.events.filter((event) => !event.features.some((feature) => cleverapps.SkinManager.SKINS[feature]));
                    if (skin !== "default") {
                        cleverapps.eventManager.setCustomFeature(skin, cleverapps.parseInterval("1 day"));
                    } else {
                        cleverapps.eventManager.setCurrentFeatures();
                    }
                };
            });
            return res;
        }),

        showLoadingSpinner: function () {
            const clickArea = new cc.Node();
            clickArea.alwaysOn = true;
            // above the loading animation, which SceneComponent adds with z-order 1000
            clickArea.setLocalZOrder(1001);
            clickArea.onResize = function () {
                const sceneSize = cleverapps.resolution.getSceneSize();
                this.setContentSize(sceneSize.width, sceneSize.height);
            };
            clickArea.onResize();
            clickArea.setAlignment({ align: "center" }, { align: "center" });

            cleverapps.UI.onClick(clickArea, () => {
                WindowComponent.hideLoading();
                clickArea.removeFromParent();
            }, {
                interactiveScale: false
            });

            cleverapps.Scenes.GetRunningScene().addChild(clickArea);

            WindowComponent.showLoading();
        },

        transition: function () {
            const scene = cleverapps.Scenes.GetRunningScene();

            if (scene.debugTransition) {
                scene.debugTransition.removeFromParent();
            }

            const transition = scene.debugTransition = Transition.create(scene);
            const transitionController = ComponentMap.getByName(transition, "TransitionController");

            transitionController.show(() => {
                transition.runAction(new cc.Sequence(
                    new cc.DelayTime(5),
                    new cc.CallFunc(() => {
                        transitionController.hide(() => {
                            transition.removeFromParent();
                            scene.debugTransition = undefined;
                        });
                    })
                ));
            });
        },

        windows: {
            twoTabsWindow: displayToolWindow(() => {
                new TwoTabsWindow();
            }),

            corruptedWindow: displayToolWindow(() => {
                new CorruptedWindow();
            }),

            conflictWindow: displayToolWindow(() => {
                new ConflictWindow({
                    localSnapshot: connector.synchronizer.getLocalSnapshot(),
                    remoteSnapshot: connector.synchronizer.getLocalSnapshot(),
                    callback: () => {}
                });
            }),

            tilesUnlockWindow: cleverapps.config.name === "zenmatch"
                ? displayToolWindow(() => {
                    new TilesUnlockWindow({
                        random: true
                    });
                }) : undefined,

            tellWindow: ToolEntry.create(() => typeof TellWindow !== "undefined", displayToolWindow(() => {
                new TellWindow({
                    text: Messages.get("TreasureSearchWindow.Help.Text"),
                    title: "TreasureSearchWindow.Help.Title"
                });
            })),

            selectFriendWindow: displayToolWindow(() => {
                new SelectFriendWindow("askLives", (() => {

                }));
            }),

            newLeague: displayToolWindow(() => {
                new LeaguesUpgradeWindow();
            }),

            rateWindow: displayToolWindow(() => {
                new RateWindow();
            }),

            victoryWindow: displayToolWindow(() => {
                if (!Game.currentGame) {
                    return;
                }

                new VictoryWindow();
            }),

            startEpisodeWindow: displayToolWindow(() => {
                new StartEpisodeWindow(levels.user.currentPhysicalLevel.episode);
            }),

            finishEpisodeWindow: (cleverapps.config.meta === "hose") ? displayToolWindow(() => {
                new FinishEpisodeWindow(cleverapps.user.currentPhysicalLevel.episode);
            }) : undefined,

            finisherWindow: ToolEntry.create(() => typeof FinisherWindow !== "undefined", displayToolWindow(() => {
                new FinisherWindow();
            })),

            signInWindow: displayToolWindow(() => {
                new SignInWindow();
            }),

            signInViralWindow: displayToolWindow(() => {
                new SignInViralWindow({
                    errorMessage: Messages.get("SignInViralWindow.TryAgain")
                });
            }),

            signInPurchaseWindow: displayToolWindow(() => {
                new SignInPurchaseWindow();
            }),

            signInWindowApple: displayToolWindow(() => {
                new SignInWindow({
                    socials: ["apple", "facebook"]
                });
            }),

            signInWindowAndroid: displayToolWindow(() => {
                new SignInWindow({
                    socials: ["android", "facebook"]
                });
            }),

            restoreProgress: displayToolWindow(() => {
                new SignInWindow({
                    restoreProgress: true
                });
            }),

            loseWindow: displayToolWindow(() => {
                new LoseWindow();
            }),

            tacticalExtendWindow: ToolEntry.create(() => typeof TacticalExtendWindow !== "undefined", displayToolWindow(() => {
                new TacticalExtendWindow();
            })),

            crossPromoWindow: function () {
                cleverapps.CrossPromo && cleverapps.CrossPromo.OpenCrossPromoWindow();
            },

            unlimitedLivesFinish: displayToolWindow(() => {
                new ExtendUnlimitedLivesWindow();
            }),

            allDone: displayToolWindow(() => {
                new AllDoneWindow();
            }),

            addBombMovesWindow: displayToolWindow(() => {
                new AddBombMovesWindow(100, "a", (() => { }), (() => { }), (() => { }));
            }),

            prolongationWindow: displayToolWindow(() => {
                new ProlongationWindow(Game.currentGame.prolongation, {
                    onGiveUp: function () { }
                });
            }),

            confirmExitWindow: displayToolWindow(() => {
                new ConfirmExitWindow();
            }),

            confirmExitAppWindow: displayToolWindow(() => {
                new ConfirmExitWindow({
                    spine: bundles.confirmexit_window.jsons.app_confirmexit_window_json,
                    source: ConfirmExitWindow.SOURCES.EXIT_APP,
                    action: function () {
                        connector.platform.closeApplication();
                    }
                });
            }),

            vipRewardedWindow: displayToolWindow(() => {
                new VIPRewardedWindow(() => { });
            }),

            emailWindow: displayToolWindow(() => {
                new EmailWindow();
            }),

            noAdsWindow: cleverapps.config.features.includes("noads") ? displayToolWindow(() => {
                new NoAdsWindow(cleverapps.offerManager.findOffer({ type: Offers.TYPES.NOADS }) || new Offer(Offers.TYPES.NOADS));
            }) : undefined,

            replaceOldMissionWindow: displayToolWindow(() => {
                new ReplaceOldMissionWindow("dragonia");
            }),

            tradeWindow: displayToolWindow(() => {
                new TradeWindow();
            }),

            adBlockWindow: displayToolWindow(() => {
                new AdBlockWindow();
            }),

            stickersBookSeasonStartWindow: displayToolWindow(() => {
                new StickersBookSeasonWindow({ isCompleted: false });
            }),

            stickersBookSeasonFinishWindow: displayToolWindow(() => {
                new StickersBookSeasonWindow({ isCompleted: true });
            }),

            migrationNoticeWindow: cleverapps.config.type === "merge2" ? displayToolWindow(() => {
                new MigrationNoticeWindow();
            }) : undefined,

            softConversionWindow: displayToolWindow(() => {
                new SoftConversionWindow({ hard: cleverapps.user.gold || 0, soft: 0 });
            }),

            newLevelsWindow: displayToolWindow(() => {
                new NewLevelsWindow();
            }),

            alternativeHard: cleverapps.config.features.includes("alternative_hard_debug") && ToolFolder.create(() => ({
                [`switch hard (${cleverapps.gameModes.alternativeHard ? "alternative" : "default"})`]: function () {
                    cleverapps.gameModes.toggle("alternativeHard");
                    cleverapps.dataLoader.processSaveQueue();
                    window.location.reload(); 
                }
            })),

            profileWindow: cleverapps.config.name === "mergecraft" ? displayToolWindow(() => {
                new ProfileWindow();
            }) : undefined,

            upgradeAvailableWindow: displayToolWindow(() => {
                new UpgradeAvailableWindow();
            }),

            pavilionOrdersWindow: cleverapps.config.name === "mergecraft" ? displayToolWindow(() => {
                new PavilionOrdersWindow();
            }) : undefined,

            landMarkExplanationWindow: cleverapps.config.name === "mergecraft" ? displayToolWindow(() => {
                const availableLandmarks = Map2dLocation.currentLocation.landmarks.listWindowLandmarks();
                const landmark = availableLandmarks[0];

                new AchievementExplanationwindow(landmark);
            }) : undefined
        },

        rewardWindows: {
            RewardWindow: displayToolWindow(() => {
                const reward = {
                    hard: 100
                };

                if (cleverapps.lives) {
                    reward.unlimitedLives = "1 day";
                }

                if (["merge", "merge2"].includes(cleverapps.config.type)) {
                    delete reward.unlimitedLives;
                    reward.wands = 10;
                    reward.soft = 100;
                    reward.unit = [{
                        code: "king",
                        stage: 0,
                        amount: 1
                    }, {
                        code: "magicplant",
                        stage: 5,
                        amount: 1
                    }];
                }

                const boosters = cleverapps.boosters.listBoostersBefore();
                if (boosters.length > 0) {
                    reward.boosters = {};
                    for (let i = 0; i < boosters.length; i++) {
                        reward.boosters[boosters[i].id] = 1;
                    }
                }

                new RewardWindow(reward, {
                    shareId: "reward",
                    event: cleverapps.EVENTS.EARN.OTHER
                });
            }),

            HeroLevelRewardWindow: displayToolWindow(() => {
                new RewardWindow({
                    herolevels: [
                        "a3",
                        "b5"
                    ]
                });
            }),

            stickersRewardWindow: cleverapps.config.features.includes("stickers_book") || cleverapps.config.features.includes("season_collections") ? displayToolWindow(() => {
                const stickers = [];
                if (StickersBook.isPuzzle()) {
                    stickers.push(cleverapps.stickersBook.collections[0].stickers[5]);
                    stickers.push(cleverapps.stickersBook.collections[0].stickers[8]);
                    stickers.push(cleverapps.stickersBook.collections[0].stickers[6]);
                } else {
                    for (let index = 2; index < 5; index++) {
                        const sticker = cleverapps.stickersBook.collections[0].stickers[index];
                        stickers.push(sticker);
                    }
                }

                stickers.forEach((sticker) => {
                    sticker.state = Sticker.STATE_OPENED;
                });

                stickers[0].attention = true;
                stickers[1].duplicate = true;
                stickers[2].attention = true;

                cleverapps.stickersBook.newStickers = stickers;

                new StickersRewardWindow(stickers);
            }) : undefined,

            stickersCompletedWindow: cleverapps.config.features.includes("stickers_book") || cleverapps.config.features.includes("season_collections") ? displayToolWindow(() => {
                cleverapps.stickersBook.collections[6].stickers.forEach((sticker) => {
                    sticker.open();
                });
                new StickersCompletedWindow(6);
            }) : undefined
        },

        offerWindows: ToolFolder.create(() => {
            const res = {};

            Object.values(Offers.TYPES).filter((type) => Offers[type] !== undefined && type !== Offers.TYPES.PACK).forEach((type) => {
                res[Offers[type].name] = displayToolWindow(() => {
                    const WindowCtor = Offers[type].view;
                    const offerManager = cleverapps.offerManager;
                    if (!offerManager.offers[type]) {
                        offerManager.addOffer(type);
                        offerManager.shownOfferTypes[type] = true;
                    }
                    new WindowCtor(offerManager.offers[type]);
                });
            });

            const type = Offers.TYPES.PACK;

            if (Offers[type]) {
                const setStarterPack = function (stage) {
                    if (!cleverapps.offerManager.inactiveOffersData[type]) {
                        cleverapps.offerManager.inactiveOffersData[type] = {};
                    }
                    cleverapps.offerManager.inactiveOffersData[type].stage = stage;

                    cleverapps.offerManager.addOffer(type);
                    cleverapps.offerManager.showOfferWindow(cleverapps.offerManager.offers[type]);
                };

                res.starterPack0 = setStarterPack.bind(null, 0);
                res.starterPack = setStarterPack.bind(null, 1);
                res.starterPack2 = setStarterPack.bind(null, 2);
            }

            return res;
        }),

        adErrorWindows: ToolFolder.create(() => {
            const res = {};

            Object.keys(RewardedAdsManager.ERROR_WINDOWS).forEach((key) => {
                res[key] = function () {
                    cleverapps.rewardedAdsManager.showAdError(key, () => {
                        console.log("AdError retry", key);
                    });
                };
            });

            return res;
        }),

        purchaseErrorWindows: ToolFolder.create(() => {
            const res = {};

            Object.keys(PaymentsLogic.ERROR_WINDOWS).forEach((key) => {
                res[key] = function () {
                    cleverapps.paymentsLogic.onPurchaseError(key);
                };
            });

            return res;
        }),

        restartWindows: ToolFolder.create(() => {
            const res = {};

            Object.keys(ErrorHandler.MESSAGES).forEach((cause) => {
                res[cause] = displayToolWindow(() => {
                    new RestartWindow({
                        messages: ErrorHandler.MESSAGES[cause],
                        retryDelay: cause === "context_lost" ? ErrorHandler.CONTEXT_LOST_RETRY_DELAY : undefined
                    });
                });
            });

            return res;
        }),

        htmlRestartWindows: ToolFolder.create(() => {
            const res = {};

            Object.keys(ErrorHandler.MESSAGES).forEach((cause) => {
                res[cause] = function () {
                    HtmlRestartWindow.show({
                        messages: ErrorHandler.MESSAGES[cause],
                        retryDelay: cause === "context_lost" ? ErrorHandler.CONTEXT_LOST_RETRY_DELAY : undefined
                    });
                };
            });

            return res;
        }),

        extrabarIconsDemo: displayToolWindow(() => {
            const icons = Object.keys(Offers).filter((o) => Offers[o] && Offers[o].extraBarIcon && !Array.isArray(Offers[o].extraBarIcon)).map(
                (o) => ({
                    name: Offers[o].name,
                    icon: typeof Offers[o].extraBarIcon === "function" ? Offers[o].extraBarIcon() : Offers[o].extraBarIcon,
                    type: Offers[o].type
                })
            );

            Object.keys(Offers).filter((o) => Offers[o] && Offers[o].extraBarIcon && Array.isArray(Offers[o].extraBarIcon)).forEach((o) => {
                Offers[o].extraBarIcon.forEach((item, index) => {
                    icons.push({
                        name: `${Offers[o].name} ${index + 1}`,
                        icon: Offers[o].extraBarIcon[index],
                        type: Offers[o].type
                    });
                });
            });

            const nodes = icons.filter((d) => d.icon.json).map((data) => {
                const iconData = data.icon;
                const background = new cc.Sprite(iconData.background || bundles.extrabar.frames.extrabar_icon_bg_green);
                const icon = new cleverapps.Spine(iconData.json);
                icon.setAnimation(0, "animation", false);
                icon.setAlignment(background.width / 2, background.height / 2);
                background.addChild(icon);

                const text = cleverapps.UI.generateOnlyText(data.name, cleverapps.styles.FONTS.WINDOW_SMALL_TEXT);
                text.fitTo(140);
                background.addChild(text);
                text.setAlignment({ align: "center" }, { align: "bottom", dy: -30 });

                cleverapps.UI.onClick(background, () => {
                    displayToolWindow(() => {
                        const type = data.type;
                        const WindowCtor = Offers[type].view;
                        const offerManager = cleverapps.offerManager;
                        if (!offerManager.offers[type]) {
                            offerManager.addOffer(type);
                            offerManager.shownOfferTypes[type] = true;
                        }
                        new WindowCtor(offerManager.offers[type]);
                    })();
                }, {
                    hover: true
                });

                return background;
            });

            new CleverappsWindow({
                title: "Extrabar icons",
                content: new cleverapps.GridLayout(nodes, {
                    columns: 9,
                    margin: {
                        x: 20,
                        y: 60
                    },
                    padding: {
                        x: 20,
                        y: 20
                    }
                })
            });
        }),

        tileshopOffersIconsDemo: displayToolWindow(() => {
            const icons = Object.keys(Offers).filter((o) => Offers[o] && Offers[o].extraBarIcon && !Array.isArray(Offers[o].extraBarIcon)).map(
                (o) => ({
                    name: Offers[o].name,
                    icon: typeof Offers[o].extraBarIcon === "function" ? Offers[o].extraBarIcon() : Offers[o].extraBarIcon,
                    type: Offers[o].type
                })
            );

            Object.keys(Offers).filter((o) => Offers[o] && Offers[o].extraBarIcon && Array.isArray(Offers[o].extraBarIcon)).forEach((o) => {
                Offers[o].extraBarIcon.forEach((item, index) => {
                    icons.push({
                        name: Offers[o].name,
                        icon: Offers[o].extraBarIcon[index],
                        type: Offers[o].type
                    });
                });
            });

            const createNodes = function () {
                return icons.filter((d) => d.icon.json).map((data) => {
                    const container = new cc.Node();
                    container.setAnchorPoint(0.5, 0.5);
                    container.setContentSize2(145, 145);

                    const name = data.name.toLowerCase();

                    if (bundles.tile_shop.frames[name]) {
                        const shopIcon = new cc.Sprite(bundles.tile_shop.frames[name]);
                        shopIcon.setAlignment(container.width / 2, container.height / 2);
                        cleverapps.UI.fitToBox(shopIcon, {
                            width: container.width,
                            height: container.height
                        });
                        container.addChild(shopIcon);
                    } else {
                        const noIconText = cleverapps.UI.generateOnlyText("no\nicon", cleverapps.styles.FONTS.WINDOW_SMALL_TEXT);
                        noIconText.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
                        noIconText.fitTo(140);
                        noIconText.setAlignment(container.width / 2, container.height / 2);
                        container.addChild(noIconText);
                    }

                    const text = cleverapps.UI.generateOnlyText(data.name, cleverapps.styles.FONTS.WINDOW_SMALL_TEXT);
                    text.fitTo(140);
                    container.addChild(text);
                    text.setAlignment({ align: "center" }, { align: "bottom", dy: -30 });

                    cleverapps.UI.onClick(container, () => {
                        displayToolWindow(() => {
                            const type = data.type;
                            const WindowCtor = Offers[type].view;
                            const offerManager = cleverapps.offerManager;
                            if (!offerManager.offers[type]) {
                                offerManager.addOffer(type);
                                offerManager.shownOfferTypes[type] = true;
                            }
                            new WindowCtor(offerManager.offers[type]);
                        })();
                    }, {
                        hover: true
                    });

                    return container;
                });
            };

            new (CleverappsWindow.extend({
                onWindowLoaded: function () {
                    const nodes = createNodes();

                    this._super({
                        title: "Tileshop offers icons",
                        content: new cleverapps.GridLayout(nodes, {
                            columns: 9,
                            margin: { x: 20, y: 60 },
                            padding: { x: 20, y: 20 }
                        })
                    });
                },
                listBundles: function () {
                    return ["tile_shop"];
                }
            }))();
        })
    },
    
    checkOfferAvailable: ToolFolder.create(() => {
        const res = {};
        Object.values(Offers.TYPES).filter((type) => Offers[type] !== undefined && cleverapps.offerManager.isOfferAvailable(type)).forEach((type) => {
            res[Offers[type].name] = function () {
                const offer = cleverapps.offerManager.offers[type];
                if (!offer.logic || !offer.logic.getProduct) {
                    return;
                }
                const product = offer.logic.getProduct(offer.logic.getLots && offer.logic.getLots()[0]);
                if (product && product.itemId) {
                    cleverapps.notification.create(`productId: ${product.itemId}`);
                }
            };
        });

        return Object.keys(res)
            .sort()
            .reduce((acc, key) => {
                acc[key] = res[key];
                return acc;
            }, {});
    }),

    resetSuppliesSale: function () {
        const type = Offers.TYPES.SUPPLIES_SALE;

        if (!Offers[type]) {
            cleverapps.notification.create("SuppliesSale: оффер не сконфигурирован, фича suppliessale выключена");
            return;
        }

        const offerManager = cleverapps.offerManager;

        if (offerManager.offers[type]) {
            offerManager.removeOffer(type);
        }

        delete offerManager.inactiveOffersData[type];
        delete offerManager.shownOfferTypes[type];

        offerManager.save();
        offerManager.refreshOffer(type);

        cleverapps.notification.create(offerManager.offers[type] ? "SuppliesSale: сброшен и выдан" : "SuppliesSale: сброшен, недоступен по условиям");
    },

    changeCustomerViewType: ToolFolder.create(() => {
        if (cleverapps.config.features.includes("map2d")) {
            const res = {};
            Object.values(Customer.VIEW).forEach((viewType) => {
                res[viewType] = () => {
                    Map2d.currentMap.customers.listCustomers().forEach((customer) => {
                        customer.setViewType(viewType);
                    });
                };
            });
            if (Map2d.currentMap && Map2d.SMILE) {
                res.smile = function () {
                    Map2d.currentMap.smile.start(true);
                };
            }

            return res;
        }
    }),
    
    ADS: ToolFolder.create(() => {
        const playRewarded = function () {
            cleverapps.rewardedAdsManager.playRewarded(AdsLimits.TYPES.HARD, () => {
                console.log("Rewarded success");
            }, (code) => {
                console.log("Rewarded fail", code);
            });
        };

        const playInterstitial = function () {
            cleverapps.rewardedAdsManager.showInterstitial({
                limit: AdsLimits.TYPES.INTERSTITIAL,
                placement: AdsLimits.TYPES.INTERSTITIAL_INACTIVE
            }, (code) => {
                console.log("Interstitial result", code);
            });
        };

        const res = {
            playRewarded,

            playRewardedOverlay: function () {
                connector.ads.getPlugin().units.rewarded.setLoaderState("ready");
                connector.ads.getPlugin()._testNoCallback = true;

                playRewarded();
            },

            playInterstitial,

            playInterstitialOverlay: function () {
                connector.ads.getPlugin().units.interstitial.setLoaderState("ready");
                connector.ads.getPlugin()._testNoCallback = true;

                playInterstitial();
            },

            fake_rewarded_off: function () {
                VideoAds.prototype.isAvailable = function () {
                    return false;
                };
                VKAds.prototype.isAvailable = function () {
                    return false;
                };
            },

            disableAds: function () {
                cleverapps.rewardedAdsManager.isRewardedSupportedOld = connector.ads.isRewardedSupported;
                connector.ads.isRewardedSupported = false;

                cleverapps.toolbar.updateItems(true);
            },

            enableAds: function () {
                connector.ads.isRewardedSupported = cleverapps.rewardedAdsManager.isRewardedSupportedOld;
            },

            connect: function () {
                connector.ads.getPlugin().setStatus(connector.STATUS_CONNECTED);
                connector.config.disableReconnect = false;
            },

            disconnect: function () {
                connector.ads.getPlugin().setStatus(connector.STATUS_DISCONNECTED);
                connector.config.disableReconnect = true;
            },

            disable: function () {
                connector.ads.getPlugin().setStatus(connector.STATUS_DISABLED);
                connector.config.disableReconnect = true;
            },

            toggleNoAdsProduct: function () {
                if (cleverapps.noAds.state === NoAds.STATE_ENABLED) {
                    cleverapps.noAds.reset();
                } else {
                    cleverapps.noAds.enable();
                }
            }
        };

        if (connector.platform.oneOf(connector.ANDROID, connector.IOS)) {
            ["AdMobAds", "YandexAppAds", "AppLovinAds"].forEach((pluginName) => {
                res[pluginName] = function () {
                    const PluginClass = window[pluginName];

                    connector.ads._installPlugin(new PluginClass());

                    cleverapps.toolModel.refresh("ADS");
                };
            });
        }

        if (connector.ads.oneOf(connector.APP_LOVIN)) {
            res.showMediationDebugger = function () {
                connector.platform.callNative("AppLovinPlugin.showMediationDebugger");
            };
        }

        if (connector.ads.oneOf(connector.YANDEX_APP_ADS)) {
            res.showDebugPanel = function () {
                connector.platform.callNative("YandexAdsPlugin.showDebugPanel");
            };
        }

        if (!connector.ads.oneOf(connector.MULTI_ADS)) {
            res.rewarded = ToolFolder.create(() => {
                const plugin = connector.ads.getPlugin();
                const proto = Object.getPrototypeOf(plugin);

                const answer = function (code, time) {
                    return function (callback) {
                        setTimeout(() => callback(code), time);
                    };
                };

                const realLoad = function (callback) {
                    setTimeout(() => proto._cacheAd.call(plugin, "rewarded", callback), 3000);
                };

                const instantLoad = function (callback) {
                    proto._cacheAd.call(plugin, "rewarded", callback);
                };

                const stub = function (loads, plays) {
                    plugin.toolRewarded = { loads, plays, armed: false };

                    if (!plugin.toolRewardedHandler) {
                        plugin.toolRewardedHandler = connector.ads.on("rewarded:loading", () => {
                            plugin.toolRewarded.armed = true;
                        });
                    }

                    plugin.canCache = function (name) {
                        return name === "rewarded" ? plugin.toolRewarded.armed : proto.canCache.call(plugin, name);
                    };

                    plugin._cacheAd = function (name, callback) {
                        if (name !== "rewarded") {
                            proto._cacheAd.call(plugin, name, callback);
                            return;
                        }

                        plugin.toolRewarded.armed = false;
                        (plugin.toolRewarded.loads.shift() || realLoad)(callback);
                    };

                    plugin._playAd = function (name, ad, callback) {
                        const play = name === "rewarded" && plugin.toolRewarded.plays.shift();
                        if (play) {
                            play(callback);
                        } else {
                            proto._playAd.call(plugin, name, ad, callback);
                        }
                    };

                    plugin.units.rewarded.loadGen++;
                    plugin.units.rewarded.setLoaderState("idle");
                };

                return {
                    [`${plugin.rewardedDuration ? ToolMenuItem.ACTIVE_ITEM : ""}longAd`]: ToolEntry.create(() => connector.ads.oneOf(connector.TEST), () => {
                        plugin.setRewardedDuration(plugin.rewardedDuration ? undefined : 35000);
                        cleverapps.toolModel.refresh();
                    }),

                    loadSucceed: function () {
                        stub([], []);
                    },

                    loadNoAds: function () {
                        stub([answer("ads_loading_no_ads", 3000)], []);
                    },

                    loadNetworkFailure: function () {
                        stub([answer("ads_loading_network_failure", 3000)], []);
                    },

                    loadTimeout: function () {
                        stub([answer("ads_loading_timeout", 11000)], []);
                    },

                    adBlock: function () {
                        if (plugin.toolAdBlock === undefined) {
                            plugin.toolAdBlock = connector._adsManager.isAdBlockEnabled;
                        }
                        connector._adsManager.isAdBlockEnabled = true;

                        stub([answer("ads_loading_failed", 3000)], []);
                    },

                    closedByUser: function () {
                        stub([], [answer("closed_by_user", 3000)]);
                    },

                    closedLate: function () {
                        stub([], [answer("closed_by_user", 31000)]);
                    },

                    playError: function () {
                        stub([realLoad, instantLoad], [answer("rewarded_unknown_error", 1000), answer("rewarded_unknown_error", 1000)]);
                    },

                    playExpired: function () {
                        stub([realLoad, instantLoad], [answer("rewarded_expired_error", 1000), answer("rewarded_expired_error", 1000)]);
                    },

                    playAlreadyRunning: function () {
                        stub([], [answer("ad_already_running", 1000)]);
                    },

                    disableRewarded: function () {
                        plugin.isRewardedSupported = function () {
                            return false;
                        };
                        cleverapps.adsLimits.notifyUpdated();
                    },

                    vip: function () {
                        cleverapps.vipAdsAdapter.getVIPStatus = function () {
                            return {
                                status: true,
                                end: Date.now() + cleverapps.parseInterval("1 day")
                            };
                        };
                        cleverapps.vipAdsAdapter.adapt();
                        cleverapps.adsLimits.notifyUpdated();
                    },

                    restore: function () {
                        if (plugin.toolRewardedHandler) {
                            plugin.toolRewardedHandler.clear();
                        }
                        ["toolRewarded", "toolRewardedHandler", "canCache", "_cacheAd", "_playAd", "isRewardedSupported"].forEach((key) => {
                            delete plugin[key];
                        });

                        if (plugin.toolAdBlock !== undefined) {
                            connector._adsManager.isAdBlockEnabled = plugin.toolAdBlock;
                            delete plugin.toolAdBlock;
                        }

                        delete cleverapps.vipAdsAdapter.getVIPStatus;
                        cleverapps.vipAdsAdapter.adapt();

                        plugin.units.rewarded.cachedErrorTime = undefined;
                        plugin.cacheAd("rewarded");
                        cleverapps.adsLimits.notifyUpdated();
                    }
                };
            });
        }

        return res;
    }),

    discord: {
        platformSafePadding: function () {
            const safePadding = connector.platform.getSafePadding();
            cleverapps.notification.create(JSON.stringify(safePadding));
        },
        calculatedSafePadding: function () {
            const safePadding = cleverapps.resolution.getSafePadding();
            cleverapps.notification.create(JSON.stringify(safePadding));
        },
        isRotated: function () {
            cleverapps.notification.create(cleverapps.resolution.isRotated);
        }
    },

    Debug: {
        debugBoneSlots: {
            flag: "debugBoneSlots"
        },

        rewardsPrice: {
            flag: "rewardsPrice"
        },

        testLoadingTime: function () {
            cleverapps.setRequestParameters({
                testLoadingTime: true,
                dropDebugMode: true
            });
        },

        setCountry: function () {
            const country = window.prompt("Enter 2 digit country code", cleverapps.country.getCountry() || "US");
            if (country && country.length === 2) {
                cleverapps.debugCountry = country.toUpperCase();
                cleverapps.country.update();
                cleverapps.bots.reload();
            }
        },

        resolution: ToolFolder.create(() => {
            const sorted = Object.keys(resolutions).sort((a, b) => resolutions[a].scale - resolutions[b].scale);

            const res = {};

            const currName = cleverapps.resolution.resolutionName;

            sorted.forEach((name) => {
                if (name !== currName) {
                    res[name] = function () {
                        cleverapps.settings.setManualResolution(name);
                    };
                } else {
                    res[`${name} [CURRENT]`] = function () { };
                }
            });

            return res;
        }),

        AtlasAnalyzer: function () {
            cleverapps.atlasAnalyzer = new AtlasAnalyzer();
            AtlasAnalyzerScene.open(cleverapps.atlasAnalyzer);
        },

        sounds: ToolFolder.create(() => {
            const modes = ["normal", "wait_all", "important_only"];
            const res = {};

            let active = cleverapps.dataLoader.load(DataLoader.TYPES.TEST_SOUNDS);
            active = modes.indexOf(active) !== -1 ? active : "normal";

            ["normal", "wait_all", "important_only"].forEach((mode) => {
                res[active === mode ? ToolMenuItem.ACTIVE_ITEM + mode : mode] = function () {
                    cleverapps.dataLoader.save(DataLoader.TYPES.TEST_SOUNDS, mode);
                    cleverapps.dataLoader.processSaveQueue();
                    cleverapps.toolModel.refresh("sounds");
                };
            });

            return res;
        }),

        logEffects: {
            flag: "logEffects"
        },

        browserLanguage: function () {
            alert(`System: ${connector.info.language} navigator: ${navigator.language}`);
        },

        clearLocalStorage: function () {
            connector.dataLoader.cleanAll();
            cleverapps.dataLoader.cleanAll();

            cleverapps.loading.show();

            setTimeout(() => window.location.reload(), 2000);
        },

        endSession: function () {
            cleverapps.playSession.endSession();
            window.location.reload();
        },

        printAllLetters: function () {
            let letters = {};
            Messages.listAll().forEach((message) => {
                // console.log(message);
                if (!Array.isArray(message)) {
                    message = [message];
                }
                message.forEach((m) => {
                    m.split("").forEach((ch) => {
                        letters[ch.toLowerCase()] = true;
                    });
                });
            });

            letters = Object.keys(letters).sort().join("");
            console.log(letters.length);
            console.log(letters);
        },

        reset: function () {
            if (cleverapps.config.importMode) {
                cleverapps.notification.create("Reseting in snapshot is impossible");
                return;
            }
            cleverapps.focusManager.display({
                stack: true,
                name: "waitReload",
                action: () => {
                    cleverapps.loading.show();
                }
            });

            cleverapps.Tool.Debug.clearLocalStorage();
            connector.dataLoader.setEnabled(false);
            cleverapps.dataLoader.setEnabled(false);
            cleverapps.snapshots.reset();

            levels.user.currentPhysicalLevel.level = 0;
            levels.user.currentPhysicalLevel.episode = 0;
            levels.user.initializeNewPlayerGold();
            levels.user.progressCompare = 0;
            levels.user.currentPhysicalLevel.progress = 0;
            levels.user.save(true);
            const id = connector.platform.getUserID();

            if (cleverapps.meta.resetProgress) {
                cleverapps.meta.resetProgress();
                cleverapps.meta.save();
            }
            if (cleverapps.knockoutGame) {
                cleverapps.knockoutGame.reset();
            }
            if (cleverapps.exp) {
                cleverapps.exp.reset();
            }

            const callback1 = function () {
                cleverapps.settings = new cleverapps.Settings(true);

                if (cleverapps.miniGame) {
                    cleverapps.miniGame = new cleverapps.MiniGame(true);
                    cleverapps.miniGame.save(true);
                }

                levels.user = new levels.User(true);
                connector.platform.setUserID(id);
                cleverapps.user = levels.user;

                if (cleverapps.boosters) {
                    cleverapps.boosters = new cleverapps.Boosters(true);
                    cleverapps.boosters.save(true);
                }

                if (cleverapps.subscription && cleverapps.subscription.isActive()) {
                    cleverapps.subscription.active = false;
                    cleverapps.subscription.save();
                }

                if (cleverapps.starChest) {
                    cleverapps.starChest = new cleverapps.StarChest(true);
                    cleverapps.starChest.save(true);
                }

                if (typeof Game !== "undefined" && Game.currentGame && Game.currentGame.storeSave) {
                    Game.currentGame.storeSave = function () { };
                }

                if (typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation) {
                    Map2dLocation.currentLocation.storeSave = function () { };
                }

                cleverapps.forces.reset();

                if (typeof cleverapps.GameSaver !== "undefined") {
                    cleverapps.GameSaver.reset();
                }

                if (typeof UnitsLibraryHelper !== "undefined") {
                    UnitsLibraryHelper.Reset();
                }

                cleverapps.dataSlots.reset();

                cleverapps.missionManager.reset();
                cleverapps.missionManager.save();

                cleverapps.friends.reset();

                if (cleverapps.serverFlags) {
                    cleverapps.serverFlags.reset();
                }

                if (cleverapps.unlimitedLives) {
                    cleverapps.unlimitedLives.reset();
                }

                if (cleverapps.lives) {
                    cleverapps.lives.reset();
                }

                if (cleverapps.noAds) {
                    cleverapps.noAds.reset();
                }

                if (cleverapps.growthFund) {
                    cleverapps.Tool.growthFund.reset();
                }

                if (cleverapps.unitsLibrary) {
                    cleverapps.unitsLibrary.reset();
                }

                if (cleverapps.unitsSyncers) {
                    cleverapps.unitsSyncers.reset();
                }

                connector.social.logout();
            };

            const callback2 = function () {
                window.location.reload();
            };

            new ActionPlayer([
                (f) => {
                    f = cleverapps.waitNoMore(1000, f);

                    if (connector.SYNC_STATUS.IDLE === connector.synchronizer.status) {
                        f();
                    } else {
                        connector.synchronizer.on("changeStatus", (status) => {
                            if (connector.SYNC_STATUS.IDLE === status) {
                                f();
                            }
                        });
                    }
                },

                (f, stop) => {
                    if (cleverapps.isLocalhost() && connector.SYNC_STATUS.IDLE !== connector.synchronizer.status) {
                        callback1();
                        cleverapps.dataLoader.processSaveQueue();
                        setTimeout(callback2, 1000);
                        stop();
                    } else {
                        f();
                    }
                },

                (f) => {
                    const iosWebView = cc.sys.OS_IOS === connector.info.os && connector.info.isNative;
                    setTimeout(callback2, iosWebView ? 1000 : 40000);
                    f();
                },

                (f) => {
                    cleverapps.dataLoader.processSaveQueue();
                    connector.synchronizer.send();
                    connector.synchronizer.once("send:success", cleverapps.waitNoMore(5000, f));
                },

                (f) => {
                    callback1();

                    cleverapps.dataLoader.processSaveQueue();
                    connector.synchronizer.send();
                    connector.synchronizer.once("send:success", cleverapps.waitNoMore(5000, f));
                },

                (f) => setTimeout(f, 500),

                (f) => {
                    callback2();
                    f();
                }

            ]).play();
        },

        adminAccess: function () {
            AdminAccess.login();
        },

        forces: {
            shownForces: ToolFolder.create(() => {
                const ids = Object.keys(Forces).filter((key) => typeof Forces[key] === "object" && cleverapps.forces.isShown(Forces[key]));

                const res = {};
                ids.forEach((id) => {
                    res[`X__${id}`] = function () {
                        cleverapps.forces.clearForce(Forces[id]);

                        cleverapps.toolModel.refresh();
                    };
                });

                return res;
            }),

            markAllShown: function () {
                if (cleverapps.forces.isRunningForce()) {
                    cleverapps.forces.closeRunningForce();
                }

                Object.keys(Forces).forEach((key) => {
                    if (typeof Forces[key] === "object" && Forces[key].id !== undefined) {
                        cleverapps.forces.saveForce(Forces[key]);
                    }
                });
            },

            clearAll: function () {
                Object.keys(Forces).forEach((key) => {
                    if (typeof Forces[key] === "object" && Forces[key].id !== undefined) {
                        cleverapps.forces.clearForce(Forces[key]);
                    }
                });
            },

            debugMinimal: {
                flag: "debugMinimal"
            }
        },

        minimal: {
            debugMinimal: {
                flag: "debugMinimal"
            }
        },

        resetWindows: {
            resetPlacements: function () {
                cleverapps.placements.resetAllPlacements();
            }
        },

        throwError: function () {
            throw "Tool Error";
        },

        instantApi: ToolFolder.create(function () {
            if (!connector.platform.oneOf(connector.INSTANT)) {
                return;
            }

            const checkApi = function (api) {
                const apis = FBInstant.getSupportedAPIs();
                console.log(`Searching ${api}`, apis);
                cleverapps.notification.create(`${api} - ${apis.includes(api)}`);
            };

            return {
                purchaseAsync: checkApi.bind(this, "payments.purchaseAsync"),
                purchaseSubscriptionAsync: checkApi.bind(this, "payments.purchaseSubscriptionAsync"),
                getRewardedVideoAsync: checkApi.bind(this, "getRewardedVideoAsync"),
                getInterstitialAdAsync: checkApi.bind(this, "getInterstitialAdAsync")
            };
        }),

        screenshots: function () {
            cleverapps.debugStats.setEnabled(false);

            if (!connector.info.isNative) {
                const body = window.document.body;
                const containers = body.getElementsByClassName("container");
                for (let i = 0; i < containers.length; i++) {
                    console.log(containers.item(i));
                    body.removeChild(containers.item(i));
                }

                const expand = body.getElementsByClassName("expand");
                for (let i = 0; i < expand.length; i++) {
                    console.log(expand.item(i));
                    body.removeChild(expand.item(i));
                }

                const commits = window.document.getElementById("commits");
                if (commits) {
                    commits.parentNode.removeChild(commits);
                }
            }

            cleverapps.refreshScene();
        },

        toggleStats: {
            flag: "toggleStatsMode"
        },

        diffMaps: ToolFolder.create(() => {
            if (cleverapps.config.name !== "differences") {
                return;
            }

            const openLink = function (ep, lvl) {
                const url = `http://differences-staging.labsystech.ru/private/levels/diffmaps/${ep}/${lvl}.png`;
                connector.platform.openUrl(url);
            };

            const res = {};

            for (let ep = 0; ep < levels.user.getEpisodesAmount(); ep++) {
                const links = {};
                for (let lvl = 0; lvl < 15; lvl++) {
                    links[lvl] = openLink.bind(undefined, ep, lvl);
                }
                res[ep] = links;
            }

            return res;
        }),

        pushes: ToolFolder.create(() => {
            const res = {};
            Object.keys(PUSHES).forEach((type) => {
                res[type] = () => {
                    const localized = PushHelper._localizePush(PUSHES[type]);
                    const showNotification = (image) => {
                        cleverapps.notification.create(localized.message, {
                            image
                        });
                    };

                    console.log(`Push title: '${localized.title}', message: '${localized.message}', image: '${localized.pushImg}'`);

                    if (localized.pushImg) {
                        cc.loader.loadImg(`${cleverapps.config.staticUrl}res/share/en/${localized.pushImg}`, (code, data) => {
                            showNotification(!code && data ? new cc.Sprite(data) : undefined);
                        });
                    } else {
                        showNotification();
                    }

                    PushHelper.sendPush(PUSHES[type], cleverapps.parseInterval("30 seconds"));
                };
            });

            return res;
        }),

        sendNotifications: function () {
            PushHelper.sendPush(PUSHES.WELCOME, cleverapps.parseInterval("1 minute"));
            cleverapps.notification.create("Test notification scheduled in 1 minute");
        },

        debugSlots: function () {
            cleverapps.Spine.debugSlots = true;
            cleverapps.refreshScene();
        },

        debugBones: function () {
            cleverapps.Spine.debugBones = true;
            cleverapps.refreshScene();
        },

        browserName: function () {
            cleverapps.notification.create(new UAParser().getBrowser().name);
        },

        userAgent: function () {
            cleverapps.notification.create(window.navigator.userAgent.toLowerCase());

            cleverapps.copyToClipboard(window.navigator.userAgent.toLowerCase());
        },

        browserType: function () {
            cleverapps.notification.create(cc.sys.browserType);
        },

        connectorInfo: function () {
            cleverapps.notification.create(JSON.stringify(connector.info));
        },

        connectorState: function () {
            let text = "";
            ["platform", "ads", "payments", "social"].forEach((name) => {
                const plugin = connector[name].getPlugin();
                const pluginName = plugin && plugin.pluginName || "none";

                text += `${name} ${pluginName}: ${connector[name].getStatus()}\n`;
            });
            cleverapps.notification.create(text);
        },

        debugInstantBanner: function () {
            cleverapps.notification.create(`canShow: ${cleverapps.bannerAd.canShow()} isStickyAvailable: ${connector.ads.isStickyAvailable
            } limit: ${cleverapps.adsLimits.state(AdsLimits.TYPES.BANNER)}`);
        },

        checkBannerAd: function () {
            cleverapps.bannerAd.check();
        },

        hideBannerAd: function () {
            connector.ads.closeStickyCallback();
        },

        islandsInfo: function () {
            cleverapps.flags.islandsInfoEnabled = true;
            cleverapps.refreshScene();
        },

        debugFont: function () {
            const createFont = function (size) {
                return {
                    name: "default",
                    fnt: true,
                    size,
                    color: cleverapps.styles.COLORS.WHITE,
                    stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
                };
            };

            const testString = "x0123456789/2+3-4";

            const createText = function (size) {
                return cleverapps.UI.generateOnlyText(testString, createFont(size));
            };

            const createImageText = function (size) {
                return cleverapps.UI.generateImageText(testString, createFont(size));
            };

            const sizes = [65, 60, 55, 50, 45, 40, 35, 30, 25, 20];

            const pairs = sizes.map((size) => {
                const text = createText(size);
                const imageText = createImageText(size);
                return new cleverapps.Layout([imageText, text], {
                    direction: cleverapps.UI.HORIZONTAL,
                    margin: 20
                });
            });

            const layout = new cleverapps.Layout(pairs, {
                direction: cleverapps.UI.VERTICAL,
                margin: 20
            });

            const scene = cleverapps.Scenes.GetRunningScene();
            layout.setAlignment({ align: "center" }, { align: "center" });
            layout.setLocalZOrder(10000);
            scene.addChild(layout);
        },

        debugButtons: function () {
            const createLayoutForSize = function (size) {
                const items = Object.keys(TextWithIcon.ICONS).filter((key) => {
                    const icon = TextWithIcon.ICONS[key][0];
                    return bundles[icon.bundle].frames[icon.name];
                }).map((key) => new cleverapps.UI.Button({
                    text: `${key}Test text`,
                    width: size.width,
                    height: size.height
                }));

                return new cleverapps.Layout(items, {
                    margin: 5,
                    direction: cleverapps.UI.VERTICAL
                });
            };

            const sizes = [
                {
                    width: 140,
                    height: 60
                },
                {
                    width: 170,
                    height: 70
                },
                {
                    width: 210,
                    height: 80
                },
                {
                    width: 250,
                    height: 90
                }
            ];

            const layouts = sizes.map((size) => createLayoutForSize(size));

            const layout = new cleverapps.Layout(layouts, {
                margin: 10,
                direction: cleverapps.UI.HORIZONTAL
            });

            const scene = cleverapps.Scenes.GetRunningScene();

            scene.addChild(layout);
            layout.setLocalZOrder(100);
            layout.setAlignment(scene.width / 2, scene.height / 2);
        },

        printProductsForCrm: function () {
            const packs = {};
            for (let i = 0; i < RewardsConfig.Packs.length; i++) {
                let packCode = "starterPack0";
                let packName = "Starter pack";
                if (i === 1) {
                    packCode = "starterPack";
                    packName = "Super pack";
                } else if (i === 2) {
                    packCode = "starterPack2";
                    packName = "Mega pack";
                }

                packs[packCode] = {
                    name: packName
                };
                Object.assign(packs[packCode], RewardsConfig.Packs[i]);
            }

            connector.payments.products.filter((product) => {
                if (["merge", "merge2"].includes(cleverapps.config.type) && ["gold500", "gold1800", "gold3800", "gold6000", "gold25000"].indexOf(product.itemId) !== -1) {
                    return true;
                }

                if (!cleverapps.lives && product.itemId.indexOf("ives") !== -1) {
                    return false;
                }

                return packs[product.itemId] === undefined && (product.itemId.indexOf("Pack") !== -1 || product.restoreReward !== undefined);
            }).forEach((product) => {
                const title = product.title.replace("", "");
                if (!Messages.has(title)) {
                    return;
                }

                packs[product.itemId] = {
                    name: Messages.get(title)
                };
                Object.assign(packs[product.itemId], product.restoreReward || product.reward);
            });

            Object.values(packs).forEach((pack) => {
                if (pack.boosters) {
                    Object.keys(pack.boosters).forEach((boosterCode) => {
                        pack[`booster${boosterCode}`] = pack.boosters[boosterCode];
                    });
                    pack.boosters = undefined;
                }

                if (pack.worker) {
                    pack.worker = cleverapps.parseInterval(pack.worker) / 3600000;
                }

                if (pack.unlimitedLives) {
                    pack.unlimitedLives = cleverapps.parseInterval(pack.unlimitedLives) / 3600000;
                }

                if (pack.energy) {
                    pack.lives = pack.energy;
                    pack.energy = undefined;
                }
            });

            console.log(JSON.stringify(packs, undefined, 4));
        },

        bannerPadding: ToolFolder.create(() => {
            const res = {};

            const plugin = connector.ads.getPlugin();

            res.none = function () {
                plugin.setBannerProbability(0);
                cleverapps.bannerAd.canShow = function () {
                    return false;
                };
                cleverapps.bannerAd.check(true);
            };

            if (!connector.platform.oneOf(connector.TEST)) {
                return res;
            }

            ["320x50", "468x60", "728x90"].forEach((bannerSize) => {
                res[bannerSize] = function () {
                    res.none();

                    const size = cc.size(+(bannerSize.split("x")[0]), +(bannerSize.split("x")[1]));

                    plugin.setBannerProbability(1);
                    plugin.setBannerSize(size);

                    cleverapps.bannerAd.canShow = function () {
                        return !cleverapps.environment.isSceneWithPreview();
                    };
                    cleverapps.bannerAd.check();
                };
            });

            return res;
        }),

        toggleTimeScale: function () {
            if (cleverapps.debugSlider.isActive()) {
                cleverapps.debugSlider.remove();
            } else {
                cleverapps.debugSlider.createTimeScaleSlider();
            }
        },

        toggleFireworksTuning: function () {
            if (cleverapps.debugSlider.isActive()) {
                cleverapps.debugSlider.remove();
            } else {
                cleverapps.debugSlider.createFireworksSlider();
            }
        },

        toggleOrangery: function () {
            if (Map2d.currentMap && Map2d.currentMap.orangery) {
                Map2d.currentMap.orangery.toggleButton();
            }
        },

        toggleZoomScale: function () {
            if (cleverapps.debugSlider.isActive()) {
                cleverapps.debugSlider.remove();
            } else {
                const toggleAction = function (value) {
                    const locationComponent = typeof Map2dLocationSceneComponent !== "undefined" && cleverapps.Scenes.GetSceneComponent(Map2dLocationSceneComponent)
                        || typeof Merge2SceneComponent !== "undefined" && cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent);
                    if (!locationComponent || cleverapps.focusManager.isFocused()) {
                        return;
                    }
                    locationComponent.animateZoom(value, 0);
                };

                cleverapps.debugSlider.create({
                    action: toggleAction,
                    minValue: 0.3,
                    maxValue: 4,
                    step: 0.1,
                    baseValue: Map2d.currentMap.scroller.zoom,
                    silent: 1
                });
            }
        },

        videoProducts: ToolFolder.create(() => {
            const shopWindow = cleverapps.focusManager.currentWindow();
            const controller = shopWindow && ComponentUtils.findComponentByName(shopWindow, "ShopWindowController");
            if (!controller) {
                return {};
            }

            const tiles = controller.tiles;

            const getController = (tile) => controller.getTileController(tile);

            const res = {
                reset: function () {
                    tiles.forEach((tile) => {
                        const controller = getController(tile);
                        cleverapps.dataLoader.save(DataLoader.TYPES.PRODUCT_VIDEO_PROGRESS + controller.product.itemId, 0);
                        controller.updateModelState();
                    });
                }
            };

            tiles.forEach((tile) => {
                const controller = getController(tile);
                if (controller.product.type === Product.TYPE_ADS) {
                    res[controller.product.itemId] = function () {
                        const amount = parseInt(window.prompt("Enter amount", controller.product.price - controller.source.currentVideoProgress() - 1));
                        if (!isNaN(amount)) {
                            controller.product.saveVideoProgress(controller.product.getVideoProgress() + amount);
                            controller.updateAvailability();
                        }
                    };
                }
            });

            return res;
        }),

        chests: ToolFolder.create(() => {
            const res = {};
            
            res.fixedChests = {
                flag: "fixedChests"
            };

            return res;
        }),

        sync: ToolFolder.create(() => {
            const res = {};

            const testCorruptedActive = cleverapps.dataLoader.load(DataLoader.TYPES.TEST_CORRUPTED);

            res[`${testCorruptedActive ? ToolMenuItem.ACTIVE_ITEM : ""}testCorrupted`] = function () {
                if (testCorruptedActive) {
                    cleverapps.dataLoader.remove(DataLoader.TYPES.TEST_CORRUPTED);
                } else {
                    cleverapps.dataLoader.save(DataLoader.TYPES.TEST_CORRUPTED, 1);
                }
                cleverapps.toolModel.refresh();
            };

            return res;
        }),

        payments: ToolFolder.create(() => {
            const res = {};

            res.stopProductsLoading = function () {
                if (cleverapps.getRequestParameters(location.hash).stopProductsLoadingDebug) {
                    cleverapps.setUrlHash({ stopProductsLoadingDebug: undefined });
                } else {
                    cleverapps.setUrlHash({ stopProductsLoadingDebug: true });
                }

                location.reload();
            };

            res.connect = function () {
                connector.payments.getPlugin().setStatus(connector.STATUS_CONNECTED);

                connector.config.disableReconnect = false;
            };

            res.disconnect = function () {
                connector.payments.getPlugin().setStatus(connector.STATUS_DISCONNECTED);

                connector.config.disableReconnect = true;
            };

            res.videoMonetization = function () {
                connector.payments.getPlugin().setStatus(connector.STATUS_DISABLED);

                connector.config.disableReconnect = true;
            };

            res.resetEmail = function () {
                cleverapps.info.setKeyValue("email", "");
            };

            const requirements = { loginRequired: "isLoginRequired", emailRequired: "isEmailRequired" };

            Object.keys(requirements).forEach((name) => {
                const property = requirements[name];

                res[`${connector.payments[property] ? ToolMenuItem.ACTIVE_ITEM : ""}${name}`] = function () {
                    const required = !connector.payments[property];
                    Object.defineProperty(connector.payments, property, { get: () => required });
                    cleverapps.toolModel.refresh("payments");
                };
            });

            res.paymentsCountry = function () {
                cleverapps.notification.create(`Country: ${connector._countryManager.country} Currency: ${connector.payments.getPlugin().currency}`);
            };

            res.showOverlay = function () {
                setTimeout(() => {
                    cleverapps.Scenes.GetRunningScene().addChild(new PaymentOverlay());
                }, 5000);
            };

            res.softCurrencyRealProduct = {
                flag: "softCurrencyRealProduct"
            };

            res[`${cleverapps.config.testRestore ? ToolMenuItem.ACTIVE_ITEM : ""}restoreCheck`] = function () {
                cleverapps.config.testRestore = !cleverapps.config.testRestore;
                cleverapps.toolModel.refresh("payments");
            };

            if (connector.platform.oneOf(connector.WECHAT)) {
                res.wechat = {
                    present1000: function () {
                        const path = `/wechat/present/${encodeURIComponent(connector.platform.getUserID())}`;
                        cleverapps.RestClient.post(path, { amount: 1000 }, (response) => {
                            console.log(`present success - ${JSON.stringify(response)}`);
                            cleverapps.notification.create(`Present - ${JSON.stringify(response)}`);
                        }, (response) => {
                            console.log("present failure", response);
                            cleverapps.notification.create("Present Failure");
                        });
                    },
                    balance: function () {
                        connector.payments.getPlugin().getBalance((balance) => {
                            cleverapps.notification.create(JSON.stringify(balance));
                        }, () => {
                            cleverapps.notification.create("Balance Failure");
                        });
                    }
                };
            }

            return res;
        }),

        abTests: ToolFolder.create(() => {
            const res = {};

            const { remoteConfig } = cleverapps.abExperiments;
            const hasRemote = Boolean(remoteConfig.remote);
            const bundleJson = bundles.abtest.jsons.abtest_json.getJson();

            const projectName = cleverapps.config.name;
            const currentSource = connector.info.source;

            const formatConditions = (available) => {
                const parts = [];
                if (available.forPayer) {
                    parts.push("payer");
                }
                if (available.level) {
                    parts.push(`lv${available.level}`);
                }
                if (available.actualLevel !== undefined) {
                    parts.push(`lv${available.actualLevel}`);
                }
                if (available.debugMode) {
                    parts.push("debug");
                }
                return parts.join(",");
            };

            const diagnose = (available) => {
                if (!available) {
                    return { display: true, blockers: [] };
                }
                if (available[projectName]) {
                    return diagnose(available[projectName]);
                }
                if (cleverapps.config.subtype && available[cleverapps.config.subtype]) {
                    return diagnose(available[cleverapps.config.subtype]);
                }
                if (available[currentSource]) {
                    return diagnose(available[currentSource]);
                }

                if (available.projectName && cleverapps.toArray(available.projectName).indexOf(projectName) === -1) {
                    return { display: false, blockers: [] };
                }
                if (available.feature !== undefined && (cleverapps.config.features || []).indexOf(available.feature) === -1) {
                    return { display: false, blockers: [] };
                }

                const blockers = [];
                if (available.disabled) {
                    blockers.push("disabled");
                }
                if (available.debugMode && !cleverapps.config.debugMode) {
                    blockers.push("debug");
                }
                if (available.registeredDate && cleverapps.user.registered < new Date(available.registeredDate).getTime()) {
                    blockers.push(`registeredDate:${available.registeredDate}`);
                }
                if (available.registeredBefore && cleverapps.user.registered >= new Date(available.registeredBefore).getTime()) {
                    blockers.push(`registeredBefore:${available.registeredBefore}`);
                }
                if (available.registered && cleverapps.user.registered + cleverapps.parseInterval(available.registered) > Date.now()) {
                    blockers.push(`registered:${available.registered}`);
                }
                if (available.types && available.types.indexOf(cleverapps.config.type) === -1) {
                    blockers.push(`type:${cleverapps.toArray(available.types).join(",")}`);
                }
                if (available.source && cleverapps.toArray(available.source).indexOf(currentSource) === -1) {
                    blockers.push(`source:${cleverapps.toArray(available.source).join(",")}`);
                }
                if (available.language && cleverapps.settings.language !== available.language) {
                    blockers.push(`language:${available.language}`);
                }
                if (available.paymentsCountry && cleverapps.country.getCountry() !== available.paymentsCountry) {
                    blockers.push(`country:${available.paymentsCountry}`);
                }
                return { display: true, blockers };
            };

            const remoteJson = hasRemote ? remoteConfig.getJson() : {};

            const localIds = Object.keys(bundleJson).filter((id) => typeof bundleJson[id] === "object");
            const remoteOnlyIds = hasRemote
                ? Object.keys(remoteJson).filter((id) => typeof remoteJson[id] === "object" && !bundleJson[id])
                : [];
            const allIds = [...localIds, ...remoteOnlyIds];

            const reverted = {};
            const adopted = {};

            allIds.forEach((id) => {
                const localEntry = bundleJson[id];
                const remoteEntry = remoteJson[id];
                const source = localEntry || remoteEntry;

                const test = {
                    ...source,
                    id,
                    status: source.status || ABExperiments.STATUS_LIVE,
                    groups: source.groups ? source.groups.map(ABExperiments.parseGroup) : ["A", "B"]
                };
                if (test.available) {
                    test.available = JSON.parse(JSON.stringify(test.available));
                }

                const structurallyAvailable = !test.available || cleverapps.user.checkAvailable(test.available, { ignoreProgress: true });
                const diagnosis = structurallyAvailable ? { display: true, blockers: [] } : diagnose(test.available);

                if (!diagnosis.display) {
                    return;
                }

                const status = test.status;
                const isActual = [ABExperiments.STATUS_LIVE, ABExperiments.STATUS_DRAFT].includes(status);
                const blocked = !structurallyAvailable;

                const group = cleverapps.abExperiments.getGroup(test);

                const eligible = !test.available || (cleverapps.user.checkAvailable(test.available) && cleverapps.paymentsHistory.checkAvailable(test.available));

                let groupPart = "";
                if (status === ABExperiments.STATUS_ADOPTED) {
                    groupPart = `>${ABExperiments.parseGroup(test.choice !== undefined ? test.choice : "A")}`;
                } else if (status !== ABExperiments.STATUS_REVERTED && eligible) {
                    groupPart = `:${group || ABExperiments.calcGroup(test)}`;
                }

                const conditions = isActual && !blocked && test.available && !eligible ? formatConditions(test.available) : "";
                const eligiblePart = isActual && !blocked && !eligible ? ` (available: ${conditions || "?"})` : "";
                const blockedPart = blocked ? ` (blocked: ${diagnosis.blockers.join(", ") || "?"})` : "";

                let syncPart = "";
                if (hasRemote) {
                    if (!remoteEntry) {
                        syncPart = " server:missing, local:ok";
                    } else if (!localEntry) {
                        syncPart = " server:ok, local:missing";
                    } else if (stableStringify(localEntry) !== stableStringify(remoteEntry)) {
                        const conflictKeys = Object.keys({ ...localEntry, ...remoteEntry })
                            .filter((key) => stableStringify(localEntry[key]) !== stableStringify(remoteEntry[key]));
                        syncPart = ` server&local:conflict(${conflictKeys.join(",")})`;
                    } else {
                        syncPart = " server&local:ok";
                    }
                }

                const name = `[${status}] ${id}${groupPart}${eligiblePart}${blockedPart}${syncPart}`;
                const target = isActual && res || status === ABExperiments.STATUS_ADOPTED && adopted || reverted;

                target[name] = () => {
                    if (!isActual || !eligible) {
                        return;
                    }
                    const currentGroup = cleverapps.abExperiments.getGroup(test) || ABExperiments.calcGroup(test);
                    const groups = test.groups;
                    const index = groups.indexOf(currentGroup);
                    const nextGroup = groups[(index + 1) % groups.length];
                    cleverapps.abExperiments.saveGroup(test, nextGroup);
                    cleverapps.abExperiments.updateGroups();
                    cleverapps.toolModel.refresh();
                };
            });

            res.adopted = ToolFolder.create(() => adopted);
            res.reverted = ToolFolder.create(() => reverted);

            return res;
        }),

        adsLimits: ToolFolder.create(() => {
            const res = {};

            const tier = cleverapps.adsLimits._getTier();
            res[`tier: ${tier}`] = () => {};

            function millisecondsToTimeString(milliseconds) {
                if (!milliseconds) {
                    return "";
                }
                const seconds = Math.floor(milliseconds / 1000);
                const hours = Math.floor(seconds / 3600);
                const minutes = Math.floor((seconds % 3600) / 60);
                const secondsLeft = seconds % 60;

                let twoDigitHours = String(hours);
                let twoDigitMinutes = String(minutes);
                let twoDigitSeconds = String(secondsLeft);

                if (twoDigitHours.length < 2) {
                    twoDigitHours = `0${twoDigitHours}`;
                }

                if (twoDigitMinutes.length < 2) {
                    twoDigitMinutes = `0${twoDigitMinutes}`;
                }

                if (twoDigitSeconds.length < 2) {
                    twoDigitSeconds = `0${twoDigitSeconds}`;
                }

                if (hours > 0) {
                    return `  ${twoDigitHours}:${twoDigitMinutes}:${twoDigitSeconds}`;
                }

                return `  ${twoDigitMinutes}:${twoDigitSeconds}`;
            }

            res.openGoogleSheet = function () {
                const url = cleverapps.config.adslimits && cleverapps.config.adslimits.remote;

                if (!url) {
                    console.log("No ads limits sheet url - it is only bundled in debug builds");
                    return;
                }

                connector.platform.openUrl(url);
            };

            Object.keys(cleverapps.adsLimits.limits).forEach((type) => {
                if (type === undefined || type === "adTiers" || type === "remote") {
                    return;
                }

                const limit = cleverapps.adsLimits.getLimit(type);

                let name;
                if (cleverapps.adsLimits.state(type) === AdsLimits.STATE_DISABLED) {
                    name = `${type} (Disabled)`;
                } else {
                    const watchCount = cleverapps.adsLimits.getWatchCount(type);
                    const watchLimit = cleverapps.adsLimits.getWatchLimit(type);
                    const timeout = cleverapps.adsLimits.getLimitLeftTime(type) || cleverapps.adsLimits.getLimitTimeout(type);
                    name = `${type} (${watchLimit === "unlimited" ? watchLimit : `${watchLimit - watchCount}/${watchLimit}`}${millisecondsToTimeString(timeout)})`;
                }

                if (cleverapps.user.checkAvailable(limit.available)) {
                    res[name] = function () {
                        if (cleverapps.adsLimits.state(type) === AdsLimits.STATE_READY) {
                            cleverapps.adsLimits.watch(type);

                            cleverapps.toolModel.refresh();
                        }
                    };
                }
            });

            res.resetAll = function () {
                Object.keys(cleverapps.adsLimits.limits).forEach((type) => {
                    cleverapps.adsLimits.reset(type);
                });
                cleverapps.toolModel.refresh();
            };

            return res;
        }),

        placementsThrottle: ToolFolder.create(() => {
            const res = {};

            res.refresh = function () {
                cleverapps.toolModel.refresh();
            };

            const state = cleverapps.placements.getThrottleState();
            const time = state.leftTime ? `  ${cleverapps.intervalToString(state.leftTime, cleverapps.placements.getThrottleInterval() > cleverapps.parseInterval("1 hour"))}` : "";

            res[`throttle ${state.count}/${Placements.THROTTLE_LIMIT}${time}`] = function () {
                cleverapps.toolModel.refresh();
            };

            state.held.forEach((code) => {
                res[`${ToolMenuItem.SUB_ITEM}${ToolMenuItem.ACTIVE_ITEM}${DebugStats.placementLabel(code) || code}`] = function () {
                    cleverapps.toolModel.refresh();
                };
            });

            (cleverapps.debugStats.shownPlacements || []).slice().reverse().forEach((shown) => {
                res[`${ToolMenuItem.SUB_ITEM}${ToolMenuItem.DONE_ITEM}${shown.code} ${new Date(shown.time).toLocaleTimeString()}`] = function () {
                    cleverapps.toolModel.refresh();
                };
            });

            res.takeSlot = function () {
                cleverapps.placements.addThrottledStart();

                cleverapps.toolModel.refresh();
            };

            res.reset = function () {
                cleverapps.placements.resetThrottle();
                cleverapps.debugStats.shownPlacements = [];

                cleverapps.toolModel.refresh();
            };

            res.throttledList = ToolFolder.create(() => {
                const missions = () => cleverapps.missionManager.getExistingTypes().map((type) => Missions[type].name || Missions[type].id);
                const offers = () => Object.values(Offers.TYPES).filter((type) => Offers[type]).map((type) => Offers[type].name);

                // what the manager entries can open in this game
                const windows = {
                    missionStartWindow: missions,
                    offerManagerProcess: offers
                };

                const list = {};

                cleverapps.placements.sortedKeys.filter((code) => Placements.ENTRIES[code].throttled).forEach((code) => {
                    list[code] = windows[code] ? ToolFolder.create(() => {
                        const names = {};
                        windows[code]().forEach((name) => {
                            names[name] = () => {};
                        });
                        return names;
                    }) : () => {};
                });

                return list;
            });

            return res;
        }),

        availables: ToolFolder.create(() => {
            const res = {};
            const availables = cleverapps.config.availables || {};

            res.openGoogleSheet = function () {
                const url = availables.remote;

                if (!url) {
                    console.log("No availables sheet url - it is only bundled in debug builds");
                    return;
                }

                connector.platform.openUrl(url);
            };

            Object.keys(availables).forEach((key) => {
                if (key === "remote" || key === "update") {
                    return;
                }

                const gate = availables[key];
                const open = cleverapps.user.checkAvailable(gate);

                let details = JSON.stringify(gate);
                if (details.length > 44) {
                    details = `${details.substr(0, 41)}...`;
                }

                res[`${key} (${open ? "open" : "locked"}) ${details}`] = function () {
                    console.log(`${key} is ${open ? "available" : "locked"}
${JSON.stringify(gate, undefined, 4)}`);
                };
            });

            return res;
        }),

        clans: ToolFolder.create(() => (cleverapps.userClan ? ClansTool : undefined)),

        sceneSize: function () {
            const size = cleverapps.resolution.getSceneSize();
            cleverapps.notification.create(`width: ${size.width} height: ${size.height}`);
        },

        throwTestError: function () {
            cleverapps.throwAsync("test error");
        },

        throwTestErrorOnLoad: function () {
            cleverapps.dataLoader.save(DataLoader.TYPES.THROWERROR, true);
            setTimeout(window.location.reload.bind(window.location), 1000);
        },

        simulateError: {
            // turn off every simulation and reload clean
            stopSimulation: function () {
                cleverapps.newVersionChecker.reset();
                cleverapps.PageSession.remove("simulatedNewVersion");
                cleverapps.PageSession.remove("simulatedLoadError");
                cleverapps.PageSession.remove("simulatedContextLost");
                cleverapps.dataLoader.processSaveQueue();
                window.location.reload();
            },

            failLoading: function () {
                cleverapps.PageSession.set("simulatedLoadError", { status: 0 });
            },

            // 404 on any resource loading while a newer version exists: open a window, expect the upgrade window; off after its reload
            failLoadingNewVersion: function () {
                cleverapps.newVersionChecker.reset();
                cleverapps.PageSession.set("simulatedLoadError", { status: 404 });
                cleverapps.PageSession.set("simulatedNewVersion", { version: Version.incPatch(cleverapps.config.version), once: true });
            },

            // web: newer version on regular check, stays on across reloads; expect window up to RELOADS_LIMIT times, then off after a successful load with upgrade_success
            newVersion: function () {
                cleverapps.newVersionChecker.reset();
                cleverapps.PageSession.set("simulatedNewVersion", { version: Version.incPatch(cleverapps.config.version) });
                cleverapps.dataLoader.processSaveQueue();
                window.location.reload();
            },

            // store app: much newer build (next major); expect old_build window on return to the tab or all_done window after all meta is complete
            newVersionStore: function () {
                cleverapps.newVersionChecker.reset();
                cleverapps.PageSession.set("simulatedNewVersion", { version: Version.incMajor(cleverapps.config.version), store: true });
                cleverapps.dataLoader.processSaveQueue();
                window.location.reload();
            },

            contextLost: function () {
                const loseContext = cc.webglContext && cc.webglContext.getExtension("WEBGL_lose_context");
                if (!loseContext) {
                    cleverapps.notification.create("contextLost: WebGL only");
                    return;
                }

                cleverapps.PageSession.set("simulatedContextLost", true);
                loseContext.loseContext();
            }
        },

        isIOSHighPerformanceMode: function () {
            cleverapps.notification.create(`isIOSHighPerformanceMode: ${GameGlobal.isIOSHighPerformanceMode}`);
        },

        lazyLoad: function () {
            displayToolPrompt((value) => {
                value = parseFloat(value.replace(",", "."));
                if (isNaN(value)) {
                    return;
                }
                if (!LazyAssets.prototype._loadBundle) {
                    LazyAssets.prototype._loadBundle = LazyAssets.prototype.loadBundle;
                }

                if (value === 0) {
                    LazyAssets.prototype.loadBundle = LazyAssets.prototype._loadBundle;
                    delete LazyAssets.prototype._loadBundle;
                    return;
                }

                LazyAssets.prototype.loadBundle = function (...args) {
                    const delayed = LazyAssets.prototype._loadBundle;
                    const scene = cleverapps.Scenes.GetRunningScene();
                    setTimeout(() => {
                        if (scene.isRunning()) {
                            delayed.apply(cleverapps.lazyAssets, args);
                        }
                    }, value * 1000);
                };
            }, "Seconds delay", 1.5);
        },

        safePadding: {
            set: function () {
                displayToolPrompt((str) => {
                    let padding = str.split(" ");
                    if (padding.length !== 4) {
                        return;
                    }

                    padding = padding.map((p) => parseInt(p));

                    cleverapps.resolution.setSafePaddingDebug(cc.padding.apply(null, padding));
                }, "Enter padding in format [top right bottom left]", "255 0 0 0");
            },
            reset: function () {
                cleverapps.resolution.setSafePaddingDebug();
            },
            showSafeArea: {
                flag: "showSafeArea"
            }
        },

        containerPadding: {
            set: function () {
                displayToolPrompt((str) => {
                    let padding = str.split(" ");
                    if (padding.length !== 4) {
                        return;
                    }

                    padding = padding.map((p) => parseInt(p));

                    cleverapps.resolution.setContainerPadding(cc.padding.apply(null, padding));
                }, "Enter padding in format [top right bottom left]", "255 0 0 0");
            },
            reset: function () {
                cleverapps.resolution.setContainerPadding();
            }
        },

        testSyncReload: function () {
            cleverapps.bundleLoader.loadBundle("snapshots", {
                onSuccess: function () {
                    const keys = Object.keys(bundles.snapshots.jsons);
                    const snapshot = cc.loader.getRes(bundles.snapshots.jsons[keys[Math.floor(Date.now() % keys.length)]]);

                    connector.dataLoader.setEnabled(false);
                    cleverapps.flags.norest = true;

                    connector.synchronizer.pull(connector.synchronizer.session, cleverapps.clone(snapshot));
                }
            });
        },

        reskinUnits: ToolFolder.create(() => {
            if (typeof Map2d === "undefined" || typeof Map2d.AVAILABLE_UNITS === "undefined") {
                return {};
            }

            const skins = {};

            Map2d.AVAILABLE_UNITS.forEach((unitSkin) => {
                const skin = unitSkin.replace("units_", "");
                if (cleverapps.skins.getSlot("skinName") === skin) {
                    skins[ToolMenuItem.ACTIVE_ITEM + skin] = function () { };
                } else {
                    skins[skin] = function () {
                        const oldSkin = cleverapps.skins.getSlot("skinName");
                        bundles[cleverapps.meta.getSelectedLocation().locationConfig.locationBundleId].meta.units = skin;
                        cleverapps.toolModel.refresh();

                        Map2dScroller.currentScroller.getScrollView().onUpdatePositionListener = cleverapps.extendFunc(Map2dScroller.currentScroller.getScrollView().onUpdatePositionListener, () => {
                            Map2d.currentMap.listAvailableUnits().forEach((unit) => {
                                unit.onRemove();
                            });

                            cleverapps.bundleLoader.deleteBundle(`units_${oldSkin}`);
                            cleverapps.bundleLoader.clearUnusedResources();

                            Map2d.currentMap.listAvailableUnits().forEach((unit) => {
                                const bundle = UnitView.GetUnitBundle(unit);
                                if (bundle && bundle.injectTo.indexOf(`units_${skin}`) !== -1) {
                                    Map2d.currentMap.onAddUnit(unit.x, unit.y, unit);
                                }
                            });
                        });

                        cleverapps.bundleLoader.loadBundle(`units_${skin}`, {
                            onSuccess: Map2dScroller.currentScroller.getScrollView().onUpdatePositionListener
                        });
                    };
                }
            });

            return skins;
        }),

        showFogBlockers: displayToolWindow(() => {
            const blockers = [];
            const config = FogsConfig.GetFog("main");

            Object.keys(config).filter((fogName) => config[fogName].conditions).forEach((fogName) => {
                const conditions = cleverapps.clone(config[fogName].conditions, true);
                if (conditions.hero) {
                    delete conditions.level;
                }
                const blocker = new FogLockView(conditions);
                blocker.setContentSize(150, 200);

                const text = cleverapps.UI.generateOnlyText(fogName, cleverapps.styles.FONTS.WINDOW_SMALL_TEXT);
                text.fitTo(140);
                blocker.addChild(text);
                text.setAlignment({ align: "center" }, { align: "bottom", dy: -16 });

                blockers.push(blocker);
            });

            new CleverappsWindow({
                title: "Fog blockers",
                content: new cleverapps.GridLayout(blockers, {
                    columns: 8,
                    margin: 60,
                    padding: {
                        x: 20,
                        y: 20
                    }
                })
            });
        }),

        nextDataLoaderVersion: function () {
            const version = cleverapps.dataLoader.version + 1;

            cleverapps.dataLoader.save(DataLoader.TYPES.VERSION, { version });
            cleverapps.dataLoader.processSaveQueue();

            connector.synchronizer.addSendTask("dataloader");

            cleverapps.dataLoader.version = version;
        },

        locationsChangedAt: function () {
            const locations = [];

            for (const bundleName in bundles) {
                const bundle = bundles[bundleName];
                if (bundle && bundle.meta && bundle.meta.location) {
                    locations.push({ location: bundleName.slice("location_".length), modified: bundle.meta.modified });
                }
            }

            const showDialog = (title, message) => {
                const dialog = document.createElement("dialog");

                dialog.innerHTML = `
                    <form method="dialog" style="padding: 16px; min-width: 200px;">
                      <h3 style="margin: 0 0 10px;">${title}</h3>
                      <p style="margin:0 0 15px; white-space: pre-line;">${message}</p>
                      <div style="text-align: right;">
                        <button value="ok">OK</button>
                      </div>
                    </form>
                  `;

                document.body.appendChild(dialog);
                dialog.showModal();

                dialog.addEventListener("close", () => {
                    dialog.remove();
                });
            };

            const shortTime = new Intl.DateTimeFormat("ru-RU", {
                dateStyle: "short",
                timeZone: "Etc/GMT-5"
            });

            const message = locations.map((data) => `${data.location} - ${shortTime.format(new DateShift.Date(data.modified))}`).join("\n");

            showDialog("Locations changes", message);
        }
    },

    SOCIAL: {
        share: ToolFolder.create(() => {
            const windows = {};

            if (cleverapps.config.type === "merge") {
                windows.achievement = function () {
                    const window = new FinishQuestWindow(Map2dLocation.currentLocation.quests.quests[0]);
                    window.needsShare = function () {
                        return true;
                    };
                };

                windows.reward = function () {
                    new RewardWindow({ worker: Workers.ADS_BONUS_WORKER_PERIOD }, { shareId: "reward" });
                };
            }

            if (cleverapps.config.type === "match3") {
                windows.victory = function () {
                    new VictoryWindow();
                };
            }

            windows.tournament = function () {
                if (cleverapps.isKnockoutGame()) {
                    new KnockoutVictoryWindow();
                } else {
                    new RewardWindow({ hard: 100 }, { shareId: "tournament", event: cleverapps.EVENTS.EARN.OTHER });
                }
            };

            const res = {};
            Object.keys(windows).forEach((shareId) => {
                res[shareId] = function () {
                    ShareCheckBoxModel.isAvailable = function () {
                        return true;
                    };

                    cleverapps.focusManager.display({
                        focus: "ToolShare",
                        action: function (f) {
                            windows[shareId]();
                            cleverapps.focusManager.onceNoWindowsListener = f;
                        }
                    });
                };
            });

            return res;
        }),

        invite: function () {
            cleverapps.SocialManager.share("invite", "default", (success) => {
                cleverapps.notification.create(`Invite result: ${success}`);
            });
        },

        listFriends: function () {
            connector.social.listFriends((code, list) => {
                if (code === cleverapps.CODE_SUCCEED) {
                    list.forEach((friend) => {
                        console.log(JSON.stringify(friend));
                    });
                }
            });
        },

        testCancel: function () {
            console.log("cancelPush");

            PushHelper.cancelPush(PUSHES.LIVES);
        },

        createShortcut: function () {
            connector.platform.createShortcutCallback((code) => {
                cleverapps.notification.create(code);
            });
        }
    },

    currency: ToolFolder.create(() => {
        const data = {
            hard_add1000: function () {
                cleverapps.user.earnHard(cleverapps.EVENTS.EARN.OTHER, 1000);
            },
            hard_add: function () {
                displayToolPrompt((value) => {
                    cleverapps.user.earnHard(cleverapps.EVENTS.EARN.OTHER, parseInt(value || "0"));
                }, "Enter amount");
            },
            hard_reset: function () {
                cleverapps.user.gold = 0;
                cleverapps.user.onChangeHard();
            }
        };

        Object.assign(data, cleverapps.Tool.extraCurrencyCommands || {});

        if (["merge", "merge2", "match3"].includes(cleverapps.config.type)) {
            data.exp_add1000 = function () {
                cleverapps.exp.setExp(cleverapps.exp.getExp() + 1000);
            };
            data.exp_add = function () {
                displayToolPrompt((value) => {
                    cleverapps.exp.setExp(cleverapps.exp.getExp() + parseInt(value || "0"));
                }, "Enter amount", 0);
            };
            data.exp_reset = function () {
                cleverapps.exp.setExp(0);
            };
        }

        if (cleverapps.config.type === "merge") {
            data.wands_add1000 = function () {
                Map2dLocation.currentLocation.setWands(Map2dLocation.currentLocation.wands + 1000);
            };
            data.wands_add = function () {
                displayToolPrompt((value) => {
                    Map2dLocation.currentLocation.setWands(Map2dLocation.currentLocation.wands + parseInt(value || "0"));
                }, "Enter amount", 0);
            };
            data.wands_reset = function () {
                Map2dLocation.currentLocation.setWands(0);
            };
            data.crops_reset = function () {
                const harvested = Map2dLocation.currentLocation.harvested;
                for (const code in harvested.items) {
                    const value = harvested.get(code);
                    harvested.take(code, value);
                }
            };
        }

        if (cleverapps.config.type === "merge2") {
            data.stars_add = function () {
                const amount = parseInt(window.prompt("Enter amount", 10));
                if (amount) {
                    const location = cleverapps.meta.getSelectedLocation();
                    location.stars.addStars(amount);
                }
            };
        }

        if (cleverapps.lives) {
            data.lives_setFull = function () {
                cleverapps.lives.setAmount(cleverapps.lives.getMaxLives());
            };
            data.lives_add1 = function () {
                cleverapps.lives.setAmount(cleverapps.lives.amount + 1);
            };
            data.lives_add = function () {
                displayToolPrompt((value) => {
                    cleverapps.lives.setAmount(cleverapps.lives.amount + parseInt(value || "0"));
                }, "Enter amount", 0);
            };
            data.lives_reset = function () {
                if (cleverapps.unlimitedLives) {
                    cleverapps.unlimitedLives.reset();
                }
                cleverapps.lives.setAmount(0);
            };

            if (cleverapps.unlimitedLives) {
                data.lives_addUnlimited = function () {
                    displayToolPrompt((time) => {
                        cleverapps.unlimitedLives.buy(time);
                        cleverapps.lives.trigger("buyUnlimitedLives");
                    }, "Time", "5 seconds");
                };

                data.lives_extendUnlimitedLivesWindow = displayToolWindow(() => {
                    new ExtendUnlimitedLivesWindow();
                });
            }
        }

        return data;
    }),

    boosters: ToolFolder.create(() => {
        const boosters = cleverapps.boosters.listAll();

        const res = {};

        const addAmount = function (id, amount) {
            cleverapps.boosters.add(id, amount);
        };

        const boostersTitle = {};
        boostersTitle[cleverapps.Boosters.TYPE_BRUSH] = "Brush";
        boostersTitle[cleverapps.Boosters.TYPE_DISCOVER] = "Discover";
        boostersTitle[cleverapps.Boosters.TYPE_MAGNET] = "Magnet";
        boostersTitle[cleverapps.Boosters.TYPE_DICE] = "Dice";
        boostersTitle[cleverapps.Boosters.TYPE_JOKERS] = "Two jokers";
        boostersTitle[cleverapps.Boosters.TYPE_HIGHLIGHT] = "Flashlight";
        boostersTitle[cleverapps.Boosters.TYPE_EYE] = "Glasses";
        boostersTitle[cleverapps.Boosters.TYPE_MAGNIFIER] = "Magnifier";

        cleverapps.boosters.listAll().forEach((booster) => {
            res[`${boostersTitle[booster.id] || "Booster title"} (id:${booster.id})`] = addAmount.bind(null, booster.id, 1);
        });

        res.reset = function () {
            boosters.forEach((booster) => {
                cleverapps.boosters.setAmount(booster.id, 0);
            });
            cleverapps.boosters.save();
        };

        return res;
    }),

    help: {
        hotKeys: ToolFolder.create(Shortcuts.GetMemo)
    },

    stickersBook: ToolFolder.create(() => {
        if (!cleverapps.stickersBook) {
            return;
        }

        function setSeasonShift(seasonIndex, year) {
            const now = new DateShift.Date();
            const targetYear = (typeof year === "number") ? year : now.getFullYear();

            const month = seasonIndex * 2;
            const seasonStart = new DateShift.Date(targetYear, month, 1, 0, 0, 0, 0);

            const delta = seasonStart.getTime() - now.getTime();
            DateShift.setShift(delta);
            cleverapps.stickersBook.updateSeason();
        }

        return {
            addJokers: function () {
                const amount = parseInt(window.prompt("Enter amount", 10));
                cleverapps.stickersBook.addJokers(amount);
            },

            addPoints: function () {
                const amount = parseInt(window.prompt("Enter amount", 10));
                cleverapps.stickersBook.incPoints(amount);
            },

            openAll: function () {
                cleverapps.focusManager.closeAllWindows();
                cleverapps.stickersBook.collections.forEach((collection) => {
                    collection.stickers.forEach((sticker) => {
                        sticker.open();
                        if (StickersBook.isPuzzle()) {
                            sticker.setAttention(false);
                        }
                    });
                });
            },

            clearAll: function () {
                cleverapps.focusManager.closeAllWindows();
                cleverapps.stickersBook.collections.forEach((collection) => {
                    collection.stickers.forEach((sticker) => {
                        sticker.state = Sticker.STATE_CLOSED;
                        sticker.setAttention(false);
                    });

                    collection.resetAttention();
                    collection.isPrizeCollected = false;
                    collection.isCompleted = false;
                });
                cleverapps.stickersBook.save();
            },

            startFeature: () => {
                cleverapps.stickersBook.setSeason(undefined);
                cleverapps.stickersBook.updateSeason();
            },

            seasons_2025: ToolFolder.create(() => ({
                startSeason0: () => {
                    setSeasonShift(0, 2025);
                },
                startSeason1: () => {
                    setSeasonShift(1, 2025);
                },
                startSeason2: () => {
                    setSeasonShift(2, 2025);
                },
                startSeason3: () => {
                    setSeasonShift(3, 2025);
                },
                startSeason4: () => {
                    setSeasonShift(4, 2025);
                },
                startSeason5: () => {
                    setSeasonShift(5, 2025);
                }
            })),

            seasons_2026: ToolFolder.create(() => ({
                startSeason0: () => {
                    setSeasonShift(0, 2026);
                },
                startSeason1: () => {
                    setSeasonShift(1, 2026);
                },
                startSeason2: () => {
                    setSeasonShift(2, 2026);
                },
                startSeason3: () => {
                    setSeasonShift(3, 2026);
                },
                startSeason4: () => {
                    setSeasonShift(4, 2026);
                },
                startSeason5: () => {
                    setSeasonShift(5, 2026);
                }
            })),

            resetToNow: () => {
                DateShift.setShift(0);
                cleverapps.stickersBook.updateSeason();
            },
            startJokerTutorial: () => {
                cleverapps.focusManager.display({
                    focus: "startStickersBookJokerTutorial",
                    action: (f) => {
                        const stickersBook = cleverapps.stickersBook;

                        cleverapps.forces.clearForce(Forces.SEASON_COLLECTIONS_JOKER_TUTORIAL);
                        stickersBook.points = StickersCollection.GOAL_POINTS;
                        stickersBook.save();

                        new StickersBookWindow(stickersBook);

                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            },

            showCollectionsSources: ToolFolder.create(() => {
                const menu = {};

                Object.keys(bundles).forEach((key) => {
                    const match = key.match(/^stickers_book_season_(\d{4})_(\d+)$/);
                    if (!match) {
                        return;
                    }

                    const year = match[1];
                    const season = match[2];
                    const seasonId = `${year}_${season}`;

                    if (!menu[year]) {
                        menu[year] = {};
                    }

                    const collectionsMenu = {};
                    let collectionsAmount = 0;
                    while (bundles[StickersCollection.getCollectionBundle(collectionsAmount, seasonId)]) {
                        const collectionName = `collection ${collectionsAmount}`;
                        const collectionIndex = collectionsAmount;

                        // eslint-disable-next-line no-loop-func
                        collectionsMenu[collectionName] = function () {
                            const currentWindow = cleverapps.focusManager.currentWindow();
                            if (currentWindow instanceof StickersCollectionWindowForTool) {
                                currentWindow.close();
                            }

                            cleverapps.focusManager.display({
                                stack: true,
                                focus: "StickersCollectionWindowForTool",
                                action: (f) => {
                                    new StickersCollectionWindowForTool({
                                        season: seasonId,
                                        index: collectionIndex
                                    });
                                    cleverapps.focusManager.onceNoWindowsListener = f;
                                }
                            });
                        };

                        collectionsAmount++;
                    }

                    menu[year][`season ${+season}`] = collectionsMenu;
                });
                return menu;
            })
        };
    }),

    achievements: ToolFolder.create(() => {
        if (!cleverapps.achievements) {
            return undefined;
        }

        const reload = function () {
            cleverapps.dataLoader.processSaveQueue();
            setTimeout(window.location.reload.bind(window.location), 0);
        };

        const makeUnknown = ToolFolder.create(() => {
            const menu = {};

            menu.clear = function () {
                cleverapps.dataLoader.remove(DataLoader.TYPES.UNKNOWN_ACHIEVEMENT_TEST);
                reload();
            };

            const expeditions = [...new Set(AchievementsConfig.filter((c) => c.expedition).map((c) => c.expedition))];
            expeditions.forEach((expedition) => {
                const configs = AchievementsConfig.listByExpedition(expedition);
                if (!configs.length) {
                    return;
                }
                menu[expedition] = function () {
                    const ids = configs.map((c) => c.id);
                    const current = cleverapps.dataLoader.load(DataLoader.TYPES.ACHIEVEMENTS);
                    const completed = Achievements.parseValue(current);
                    const withIds = cleverapps.toBitBase64([...new Set(completed.concat(ids))]);
                    cleverapps.dataLoader.save(DataLoader.TYPES.ACHIEVEMENTS, withIds);
                    cleverapps.dataLoader.save(DataLoader.TYPES.UNKNOWN_ACHIEVEMENT_TEST, ids);
                    reload();
                };
            });

            return menu;
        });

        return { makeUnknown };
    }),

    weeklyGoals: ToolFolder.create(() => (!cleverapps.weeklyGoals ? undefined : {
        regenerate: function () {
            const originalCalcWeekSeed = cleverapps.weeklyGoals.calcWeekSeed;

            cleverapps.weeklyGoals.calcWeekSeed = function () {
                return Math.floor(Math.random() * 100000) + 1;
            };

            cleverapps.weeklyGoals.addPoints(-cleverapps.weeklyGoals.points);
            cleverapps.weeklyGoals.updateGoals(true);

            cleverapps.weeklyGoals.calcWeekSeed = originalCalcWeekSeed;

            const window = cleverapps.focusManager.currentWindow();
            if (window instanceof WeeklyGoalsWindow) {
                window.close();
            }

            cleverapps.weeklyGoals.displayWindow();
        },

        addPoints: function () {
            const amount = parseInt(window.prompt("Enter amount", 10));
            cleverapps.weeklyGoals.addPoints(amount);
        },

        resetProgress: function () {
            const window = cleverapps.focusManager.currentWindow();
            if (window instanceof WeeklyGoalsWindow) {
                window.close();
            }
            
            cleverapps.weeklyGoals.progress = {};
            cleverapps.weeklyGoals.goals.forEach((goals) => {
                goals.forEach((goal) => {
                    goal.collected = false;
                });
            });
            cleverapps.weeklyGoals.save();
        }
    })),

    subscriptions: ToolFolder.create(() => {
        const res = {};
        if (!Subscription.IsAvailable()) {
            return res;
        }

        const getServerInfo = function (callback) {
            return function () {
                const params = {
                    source: connector.info.source,
                    tokens: cleverapps.subscription.tokens
                };
                cleverapps.RestClient.get(`/subscriptions/getinfo/${connector.platform.getUserID()}`, params, (subscription) => {
                    subscription = subscription || { data: cleverapps.subscription.getInfo() };
                    console.log(`subscription - ${JSON.stringify(subscription)}`);
                    callback(subscription);
                });
            };
        };

        res.serverInfo = getServerInfo((subscription) => {
            displayToolWindow(() => {
                new ToolSubscriptionWindow(subscription);
            })();
        });

        if (cleverapps.isLocalhost() || connector.platform.oneOf(connector.CLEVERAPPS) && cleverapps.config.debugMode) {
            res.cancel = function () {
                if (cleverapps.subscription.isActive()) {
                    cleverapps.subscription.active = false;
                    cleverapps.subscription.save();
                    cleverapps.subscription.trigger("update");
                }
            };
        }
        res.setRewardTime = function () {
            const interval = window.prompt("Enter time", "5 seconds");
            if (!interval) {
                return;
            }
            const time = cleverapps.parseInterval(interval);
            cleverapps.subscription.rewardTime = Date.now() - cleverapps.parseInterval(Subscription.REWARD_INTERVAL) + time;
            cleverapps.subscription.save();
        };
        return res;
    }),

    missions: ToolFolder.create(function () {
        return MissionsTool.getToolItems(this);
    }),

    disabledProducts: ToolFolder.create(() => {
        const res = {};
        const itemIds = connector.payments.getPlugin().listProducts().map((product) => product.itemId).sort();
        itemIds.forEach((itemId) => {
            res[(DisabledProducts.isDisabled(itemId) ? ToolMenuItem.ACTIVE_ITEM : "") + itemId] = function () {
                DisabledProducts.toggle(itemId);
                cleverapps.toolModel.refresh();
            };
        });
        return res;
    }),

    paymentsHistory: {
        add500: function () {
            cleverapps.paymentsHistory.addPayment(Product.CreateById("gold500"));
        },
        add1800: function () {
            cleverapps.paymentsHistory.addPayment(Product.CreateById("gold1800"));
        },
        add6000: function () {
            cleverapps.paymentsHistory.addPayment(Product.CreateById("gold6000"));
        },
        add25000: function () {
            cleverapps.paymentsHistory.addPayment(Product.CreateById("gold25000"));
        },
        resetPaymentsHistory: function () {
            cleverapps.dataLoader.remove(DataLoader.TYPES.PAYMENTS_HISTORY);
            cleverapps.paymentsHistory.reset();
            cleverapps.subscription.reset();
        },
        checkClassify: function () {
            const postfix = cleverapps.vipAdsAdapter.isVIP() ? " (VIP)" : " (no VIP)";
            const groupNames = Object.keys(cleverapps.PaymentsHistory);
            const group = cleverapps.paymentsHistory.classify();
            let name;
            for (let i = 0; i < groupNames.length; i++) {
                if (cleverapps.PaymentsHistory[groupNames[i]] === group) {
                    name = groupNames[i];
                    break;
                }
            }

            const tier = cleverapps.adsLimits._getTier();

            console.log(cleverapps.paymentsHistory.getInfo());
            cleverapps.notification.create(`bracket=${name} tier=${tier}${postfix}`);
        },
        checkVIPStatus: function () {
            const postfix = cleverapps.vipAdsAdapter.isVIP() ? " (VIP)" : " (no VIP)";

            const groupNames = Object.keys(cleverapps.PaymentsHistory).filter((key) => key.startsWith("BRACKET_"));

            const status = cleverapps.paymentsHistory.classify();
            let name;
            for (let i = 0; i < groupNames.length; i++) {
                if (cleverapps.PaymentsHistory[groupNames[i]] === status) {
                    name = groupNames[i];
                    break;
                }
            }

            cleverapps.notification.create(`Payer vip status = ${name}${postfix}`);
        },

        vipRewardedWindow: displayToolWindow(() => {
            new VIPRewardedWindow(() => { });
        })
    },

    audio: {
        logState: function () {
            const context = cc.Audio._context;

            console.log(
                "audio state",
                cleverapps.audio.disk,
                cleverapps.audio.muted,
                cleverapps.audio.volume,
                cleverapps.audio.currentFade,
                context && context.state,
                context && context.currentTime,
                context && context.baseLatency
            );
        },

        resume: function () {
            cc.Audio._context.resume();
        },

        currentSceneDelay: function () {
            const audioStyles = cleverapps.Scenes.GetRunningScene().sceneComponent.audioStyles;
            if (audioStyles) {
                console.log(`### Current scene delay: ${audioStyles.delay}`);
            } else {
                console.log("### No audio styles for scene");
            }
        },

        setSceneDelay: function () {
            const delay = parseFloat(window.prompt("Delay", 1));
            if (isNaN(delay)) {
                console.log("### Wrong value");
                return;
            }

            const scene = cleverapps.Scenes.GetRunningScene();
            const audioStyles = scene.sceneComponent.audioStyles;
            if (!audioStyles) {
                console.log("#### No audio styles for current scene");
                return;
            }

            if (ComponentMap.get(scene, GameSceneComponent)) {
                cleverapps.styles.GameScene.sound.delay = delay;
                console.log(`#### GameSceneBase set to ${delay}`);
            } else if (ComponentMap.get(scene, SceneComponent)) {
                cleverapps.styles.SceneComponent.sound.delay = delay;
                console.log(`#### SceneComponent set to ${delay}`);
            }
        }
    },

    events: ToolFolder.create(() => {
        const res = {};
        const constructEventName = function (eventData, isActive) {
            const event = new cleverapps.Event(eventData);
            let name = event.features.join(", ");
            const networks = eventData.networks || (eventData.trueData && eventData.trueData.networks);
            if (networks) {
                let networksPrefix = `[${networks[0]}`;
                networksPrefix += networks[1] ? `, ${networks[1]}` : "";
                networksPrefix += networks[2] ? "..." : "";
                networksPrefix += "] ";
                name = networksPrefix + name;
            }
            name = isActive ? `${ToolMenuItem.ACTIVE_ITEM + name} (${new Date(eventData.finish).toLocaleDateString("ru", {
                day: "numeric", month: "numeric", hour: "numeric", minute: "numeric"
            })})` : name;
            return name;
        };

        let noDublicateEvents = [];
        cleverapps.eventManager.events.forEach((event) => {
            noDublicateEvents = noDublicateEvents.filter((filteredEvent) => JSON.stringify(event.features.slice(0).sort()) !== JSON.stringify(filteredEvent.features.slice(0).sort()));
            noDublicateEvents.push(event);
        });

        noDublicateEvents.forEach((eventData) => {
            const event = new cleverapps.Event(eventData);
            const isApplicable = cleverapps.eventManager.isEventApplicable(event);

            res[constructEventName(eventData, isApplicable)] = function () {
                eventData.toolApplicable = !isApplicable;

                if (eventData.toolApplicable) {
                    eventData.trueData = {
                        start: eventData.start,
                        finish: eventData.finish,
                        networks: eventData.networks
                    };
                    const date = new Date();
                    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
                    date.setSeconds(date.getSeconds() - 1);
                    eventData.start = cleverapps.convertToTimezone(date.toISOString());
                    date.setSeconds(date.getSeconds() + 60 * 60);
                    eventData.finish = cleverapps.convertToTimezone(date.toISOString());
                    delete eventData.networks;
                } else if (eventData.trueData) {
                    eventData.start = eventData.trueData.start;
                    eventData.finish = eventData.trueData.finish;
                    eventData.networks = eventData.trueData.networks;
                    delete eventData.trueData;
                }

                cleverapps.refreshScene();
            };
        });
        return res;
    }),

    friendRequests: {
        create: function () {
            levels.friendRequests.listAvailableTypes().forEach((type) => {
                let from = levels.FriendRequest.SYSTEM_ID;
                const friend = cleverapps.friends.listInAppFriends()[0];
                if (friend && friend.id) {
                    from = friend.id;
                }

                const request = {
                    id: `__${Math.floor(Math.random() * 1000000000000000)}`,
                    from,
                    type,
                    fake: true
                };

                levels.friendRequests.notProcessed.push(levels.FriendRequest.createFriendRequest(request));
                levels.friendRequests.save();
                levels.friendRequests.trigger("load");
            });
        },
        clear: function () {
            levels.friendRequests.notProcessed = [];
            levels.friendRequests.save();
        }
    },

    cups: {
        daily: {
            addStars: function (cup) {
                cup = cup || cleverapps.dailyCup;

                const amount = parseInt(window.prompt("Enter stars", "10"));
                const reward = new Reward("cup", {
                    type: cup.type,
                    amount
                });
                reward.receiveReward();

                cup.reload();
            },

            addPlayers: function (cup) {
                cup = cup || cleverapps.dailyCup;
                if (cup.id) {
                    connector.multi.cups.addFakePlayers(cup.id, 10, () => {
                        setTimeout(() => {
                            cup.reload();
                        }, 500);
                    });
                }
            }
        },

        weekly: {
            addStars: function () {
                cleverapps.Tool.cups.daily.addStars(cleverapps.weeklyCup);
            },

            addPlayers: function () {
                cleverapps.Tool.cups.daily.addPlayers(cleverapps.weeklyCup);
            }
        },

        clan: {
            addStars: function () {
                cleverapps.Tool.cups.daily.addStars(cleverapps.clanCup);
            },

            addPlayers: function () {
                cleverapps.Tool.cups.daily.addPlayers(cleverapps.clanCup);
            }
        },

        weeklyTournament: {
            goToLevel: function () {
                const currentLevel = cleverapps.weeklyTournament.cup.score;
                const level = parseInt(window.prompt("Enter level", "10"));
                cleverapps.weeklyTournament.cup.addAmount(level - currentLevel - 1);

                cleverapps.weeklyTournament.save();
                cleverapps.weeklyTournament.load();
                cleverapps.refreshScene();
            },

            goToNextReward: function () {
                const rewardLevel = cleverapps.weeklyTournament.getLevel();

                while (rewardLevel < WeeklyTournament.LEVELS_AMOUNT && !cleverapps.weeklyTournament.isRewardLevel()) {
                    cleverapps.weeklyTournament.onLevelPassed();
                }

                cleverapps.weeklyTournament.save();
                cleverapps.weeklyTournament.load();
                cleverapps.refreshScene();
            }
        }
    },

    bonusWorld: {
        gotoLevel: function () {
            const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_BONUS_WORLD);
            if (mission) {
                const levelNo = parseInt(window.prompt("level number", 15)) - 1;
                if (!isNaN(levelNo)) {
                    const receivedRewards = mission.details.receivedRewards || {};

                    for (let i = 0; i < RewardsConfig.BonusWorld.length; i++) {
                        if (RewardsConfig.BonusWorld[i].level >= levelNo) {
                            delete receivedRewards[RewardsConfig.BonusWorld[i].level];
                        }
                    }

                    const details = mission.details;
                    details.receivedRewards = receivedRewards;

                    mission.update(levelNo - mission.result, details);

                    cleverapps.refreshScene();
                }
            }
        }
    },

    slotMachine: ToolFolder.create(() => ({
        setPayline: function () {
            const codes = {
                c: "coin",
                cs: "coins",
                b1: "booster_1",
                b2: "booster_2",
                b3: "booster_3"
            };

            let msg = "Enter 3 elements, separated by comma";
            for (const code in codes) {
                msg = `${msg}\n ${code}: ${codes[code]}`;
            }

            SlotMachine.PREDEFINED_PAYLINE = window.prompt(msg, "c,c,c")
                .replace(/ /g, "")
                .split(",")
                .map((code2) => codes[code2]);
        },

        resetPayline: function () {
            delete SlotMachine.PREDEFINED_PAYLINE;
        },

        addTicket: function () {
            const reward = new Reward("mission", { missionType: Mission.TYPE_SLOT_MACHINE, amount: 1 });
            reward.receiveReward();
            reward.onAnimationFinished();
        },

        resetTickets: function () {
            const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_SLOT_MACHINE);

            const reward = new Reward("mission", { missionType: Mission.TYPE_SLOT_MACHINE, amount: -mission.logic.getTickets() });
            reward.receiveReward();
            reward.onAnimationFinished();
        },

        resetForces: function () {
            cleverapps.forces.clearForce(Forces.SLOT_MACHINE);
            cleverapps.forces.clearForce(Forces.SLOT_MACHINE_ICON);
            cleverapps.forces.clearForce(Forces.SLOT_MACHINE_HELP);
        }
    })),

    personWindows: {
        ConfirmSpeedUpWindow: displayToolWindow(() => {
            new ConfirmSpeedUpWindow({
                timeLeft: cleverapps.parseInterval("1 minute"),
                totalDuration: cleverapps.parseInterval("1 minute"),
                eventName: cleverapps.EVENTS.SPENT.ORDER,
                callback: function () { }
            });
        }),

        SpeedUpWindow: displayToolWindow(() => {
            new SpeedUpWindow({
                getTimeLeft: function () {
                    return cleverapps.parseInterval("1 minute");
                },
                getFullJobTime: function () {
                    return cleverapps.parseInterval("1 minute");
                },
                isSpeedUpBonusActive: function () {
                    return false;
                }
            });
        }),

        LevelUpWindow: displayToolWindow(() => {
            new LevelUpWindow();
        })
    },

    game: {
        win: function () {
            if (Game.currentGame) {
                Game.currentGame.win();
            }
        },

        lose: function () {
            if (Game.currentGame) {
                Game.currentGame.lose();
            }
        },

        "no moves": function () {
            if (Game.currentGame && Game.currentGame.noMoves) {
                Game.currentGame.noMoves();
                Game.currentGame.counter.trigger();
            }
        },

        modes: ToolFolder.create(() => {
            const res = {
            };

            cleverapps.gameModes.listModes().forEach((flagName) => {
                res[(cleverapps.gameModes[flagName] ? ToolMenuItem.ACTIVE_ITEM : "") + flagName] = function () {
                    cleverapps.gameModes.toggle(flagName);
                    cleverapps.toolModel.refresh();

                    cleverapps.eventBus.trigger(`toggleGameMode:${flagName}`);
                };
            });

            return res;
        }),

        exclamations: ToolFolder.create(() => {
            const res = {};
            res.random = function () {
                const msg = PseudoRandom.GET().mathChoose(cleverapps.exclamation.getCongratulations());
                cleverapps.exclamation.show(msg);
            };
            return res;
        })
    },

    promocodes: ToolFolder.create(() => {
        const res = {};
        for (const code in PromoCodes.CODES) {
            if (cleverapps.promoCodes.isUsedCode(code)) {
                // eslint-disable-next-line no-loop-func
                res[code] = function () {
                    let used = cleverapps.dataLoader.load(DataLoader.TYPES.PROMOCODES);
                    used = used.filter((usedCode) => usedCode !== code);
                    cleverapps.dataLoader.save(DataLoader.TYPES.PROMOCODES, used);
                    cleverapps.toolModel.refresh();
                };
            }
        }
        return res;
    }),

    SAMSUNG: ToolFolder.create(() => {
        if (!connector.platform.oneOf(connector.SAMSUNG)) {
            return;
        }

        return {
            showUserId: function () {
                cleverapps.notification.create(connector.platform.getUserID());
            },
            loginUser: function () {
                cleverapps.SocialManager.login((success) => {
                    if (!success) {
                        cleverapps.SocialManager.onFailedLogin();
                    }
                });
            },
            restart: function () {
                GSInstant.restart();
            },
            canCreateShortcut: function () {
                console.log(GSInstant.canCreateShortCut());
                cleverapps.notification.create(GSInstant.canCreateShortCut());
            },
            getLoginStatus: function () {
                const retObj = GSInstant.getLoginStatus();
                cleverapps.notification.create(retObj.result || retObj.err);
            },
            getUserIdAsync: function () {
                GSInstant.player.getPlayerIdAsync()
                    .then((playerId) => {
                        cleverapps.notification.create(playerId);
                    })
                    .catch((err) => {
                        cleverapps.notification.create(err);
                    });
            },
            paymentsIsReady: function () {
                cleverapps.notification.create(connector.payments.isConnected());
            },
            productInfo: function () {
                const product = connector.payments.getProduct("gold500");

                cleverapps.notification.create(`textPrice: ${product.textPrice}, price: ${product.price}`);
            },
            getProducts: function () {
                try {
                    GSInstantIAP.getProductListAsync().then((products) => {
                        console.log(
                            "getProducts success",
                            products && products[0] && products[0].mItemId,
                            products && products[0] && products[0].mItemPriceString
                        );
                    }).catch((err) => {
                        console.log(`getProducts catch${err}`);
                    });
                } catch (err) {
                    console.log(`getProducts error ${err}`);
                }
            },
            getProductListAsync: function () {
                GSInstantIAP.getProductListAsync();
            }
        };
    })
};

cleverapps.whenAllInitialized(() => {
    const remoteConfig = cleverapps.abExperiments.remoteConfig;
    const remoteProject = remoteConfig.project;

    if (!remoteProject) {
        return;
    }

    const checkSync = function () {
        const localJson = bundles.abtest.jsons.abtest_json.getJson();
        const remoteData = remoteProject.getValue(remoteConfig.key) || {};
        const allIds = new Set([...Object.keys(localJson), ...Object.keys(remoteData)]);

        allIds.forEach((id) => {
            const localEntry = localJson[id];
            const remoteEntry = remoteData[id];
            const source = localEntry || remoteEntry;
            const status = source.status || ABExperiments.STATUS_LIVE;

            if (![ABExperiments.STATUS_LIVE, ABExperiments.STATUS_DRAFT].includes(status)) {
                return;
            }

            if (source.available && !cleverapps.user.checkAvailable(source.available, { ignoreProgress: true })) {
                return;
            }

            let syncIssue = "";
            if (!remoteEntry) {
                syncIssue = "server:missing, local:ok";
            } else if (!localEntry) {
                syncIssue = "server:ok, local:missing";
            } else if (stableStringify(localEntry) !== stableStringify(remoteEntry)) {
                syncIssue = "server&local:conflict";
            }

            if (syncIssue) {
                cleverapps.throwAsync(`AB test '${id}' sync issue: ${syncIssue}`);
            }
        });
    };

    if (remoteProject.fetched) {
        checkSync();
    } else {
        remoteProject.on("fetch", checkSync);
    }
});
